<template>
    <div class="animated fadeIn" v-if="isVoucherLoaded()">

        <h3>Путевка #{{ voucher.id }} <small>Статус: {{ getVoucherStatusName(voucher.status_index) }}
            {{voucher.status_index}} </small>
            &nbsp;

            <b-button variant="ghost-primary" id="reload-button-top" @click="reloadVoucher()">
                <i class="fa fa-refresh"></i>&nbsp;
            </b-button>

            <b-button variant="ghost-success" id="save-button-top" @click="onApply()" v-if="canSave(voucher)">
                <i class="fa fa-save"></i>&nbsp;
            </b-button>

            <b-button variant="ghost-primary" id="reminder-button" @click="onCreateTask()">
                <i class="fa fa-bell-o"></i>&nbsp;
            </b-button>

            <b-button :variant="status_expired?'ghost-danger':'ghost-secondary'" id="needaction-button"
                      v-if="must_close_status" @click="showStatusDialog=true">
                <i class="fa fa-clock-o" :class="status_bell_class"></i>&nbsp; {{ voucher.status_action_info }} до <span
                v-html="printDateTime(_close_status_at, false, true)"/>
            </b-button>

            <b-tooltip target="reload-button-top">Перезагрузить путевку</b-tooltip>
            <b-tooltip target="save-button-top">Сохранить путевку</b-tooltip>
            <b-tooltip target="reminder-button">Создать задачу</b-tooltip>
            <b-tooltip target="needaction-button">Изменение необходимого действия и времени выполнения</b-tooltip>

        </h3>

        <b-alert show variant="danger" v-if="voucher.sys_comments_canceled">
            {{ voucher.sys_comments_canceled }}
        </b-alert>

        <b-alert show variant="danger" v-if="voucher.sys_comments_refuse">
            {{ voucher.sys_comments_refuse }}
        </b-alert>

        <div class="row">
            <b-col md="6">

                <b-card v-if="is_voucher_company" no-body>
                    <div slot="header">
                        <strong>Организационное</strong>
                        <div class="card-header-actions">
                            <b-link class="card-header-action btn-minimize" v-b-toggle.collapse_company>
                                <i class="icon-arrow-up"></i>
                            </b-link>
                        </div>
                    </div>

                    <b-collapse id="collapse_company" visible v-model="show_company">
                        <b-card-body>

                            Путевка создана <span v-html="printDateTime(voucher.date_create_iso, false, true)"/><br/>
                            Текущий статус "{{ getVoucherStatusName(voucher.status_index) }}" открыт <span
                            v-html="printDateTime(voucher.status_changed_at, false, true)"/><br/>

                            <!--
                            [ status_expired = {{ status_expired }} ]<br>
                            [ now = <span v-html="printDateTime(new Date(), false, true)" /> ]<br>
                            [ d = <span v-html="printDateTime(voucher.close_status_at, false, true)" /> ]<br>
                            -->

                            <template v-if="must_close_status">
                                <template v-if="status_expired">
                                    <span class="hitexh">
                                        Срочно выполните действие "{{ voucher.status_action_info }}"
                                    </span>
                                </template>
                                <template v-else>
                                    Необходимо выполнить действие "{{ voucher.status_action_info }}" до <span
                                    v-html="printDateTime(_close_status_at, false, true)"/>
                                </template>
                            </template>
                            <template v-else>
                                <template v-if="status_expired">
                                    <span>
                                        Закрытие статуса  просрочено: <span
                                        v-html="printDateTime(_close_status_at, false, true)"/>
                                    </span>
                                </template>
                                <template v-else>
                                    Закрытие статуса планируется до: <span
                                    v-html="printDateTime(_close_status_at, false, true)"/>
                                </template>
                            </template>


                            <br/>

                            <template v-if="is_admin||is_manager_or_buh">
                                Агент: {{ voucher.user.name_ }} {{ voucher.user.patro }} {{ voucher.user.surname }} ({{
                                voucher.user.login }}) <a href="#" @click.prevent="loginAs(voucher.user.id)"
                                                          v-if="is_admin"> <i class="icon-login text-primary"></i></a>

                                <template v-if="is(voucher.user.local_phone_stat)"><br><span
                                    style="padding-left:10px"></span>тел: <a
                                    :href="'tel:'+voucher.user.local_phone_stat">{{voucher.user.local_phone_stat}}</a>
                                </template>
                                <template v-if="is(voucher.user.phone_mobi)"><br><span style="padding-left:10px"></span>тел:
                                    <a :href="'tel:'+voucher.user.phone_mobi">{{voucher.user.phone_mobi}}</a></template>
                                <template v-if="is(voucher.user.email)"><br><span style="padding-left:10px"></span>e-mail:
                                    <a :href="'email:'+voucher.user.email">{{voucher.user.email}}</a></template>
                                <br>Агентство: {{ voucher.company.title }}
                                <template v-if="is(voucher.company.phones)"><br><span style="padding-left:10px"></span>тел:
                                    {{voucher.company.phones}}
                                </template>
                                <template v-if="is(voucher.company.email)"><br><span style="padding-left:10px"></span>e-mail:
                                    <a :href="'email:'+voucher.company.email">{{voucher.company.email}}</a></template>
                            </template>
                            <template v-if="!canEditCompany()">
                                <b-form-group v-if="is(voucher.doccompany)">
                                    <br>Юрлицо для документов: <strong>{{ voucher.doccompany.title }}</strong><br>
                                </b-form-group>
                            </template>
                            <template v-if="canEditCompany()">
                                <b-form-group label="Юрлицо для документов:">
                                    <b-form-select
                                        :plain="true"
                                        value-field="id"
                                        text-field="title"
                                        v-model="voucher.doc_company_id"
                                    >
                                        <option :value="voucher.company.id">{{company_title}}</option>
                                        <option v-for="doccompany in voucher.doccompanies" :key="doccompany.id"
                                                :value="doccompany.id">{{doccompany.title}}
                                        </option>
                                    </b-form-select>
                                </b-form-group>
                            </template>

                            <template v-if="canChangeTransferCompany(voucher)">
                                <b-form-group
                                    description="Включение этой опции разрешает просмотр сотрудниками НСБ контактных данных заказчика на этапе подготовки документов и трансфера">
                                    <div class="custom-control custom-checkbox custom-control-inline">
                                        <input type="checkbox" class="custom-control-input" id="transfer_by_nsb"
                                               value="1" v-model="voucher.transfer_by_nsb">
                                        <label class="custom-control-label" for="transfer_by_nsb">Трансфер НСБ</label>
                                    </div>
                                </b-form-group>
                            </template>
                            <template v-else>
                                <p v-if="voucher.transfer_by_nsb">
                                    <strong>Заказан трансфер НСБ</strong>
                                </p>
                            </template>

                            <b-alert class="info" v-if="is_admin">
                                Можно в кассу:
                                Кисловодск, Солнечный |
                                Кисловодск, Родник |
                                Кисловодск, Радуга |
                                Кисловодск, Плаза |
                                Пятигорск, Тарханы |
                                Пятигорск, Зори Ставрополья |
                                Пятигорск, Галерея Палас |
                                Железноводск, Плаза СПА |
                                Ессентуки, Казахстан |
                                Ессентуки, Шахтер |
                                Ессентуки, Русь |
                                Ессентуки, Источник |
                                Архыз, Туристическая база Алания
                            </b-alert>


                            <template v-if="canChangeDirectPayment(voucher, hotel) ">
                                <b-form-group
                                    description="при включении прямой оплаты никакие счета выставляться не будут">
                                    <div class="custom-control custom-checkbox custom-control-inline">
                                        <input type="checkbox" class="custom-control-input" id="direct_payment"
                                               value="1" v-model="voucher.m_payment_obj">
                                        <label class="custom-control-label" for="direct_payment">Прямая оплата в кассу
                                            объекта размещения</label>
                                    </div>
                                </b-form-group>
                            </template>
                            <template v-else>
                                <p v-if="voucher.m_payment_obj">
                                    <strong>Прямая оплата в кассу объекта размещения</strong>
                                </p>
                            </template>

                            <template v-if="hotel && (is_manager_or_buh || is_admin)">
                                <p v-if="hotel.extern_disabled">
                                    <strong>Прямое бронирование</strong>
                                </p>
                                <p v-else>
                                    <strong>Бронирование через Профкурорт</strong>
                                </p>
                            </template>

                            <template v-if="is_agent_or_agency || is_manager_or_buh || is_admin">
                                <b-form-group
                                    description="при включении прямой оплаты никакие счета выставляться не будут">
                                    <div class="custom-control custom-checkbox custom-control-inline">
                                        <input type="checkbox" class="custom-control-input" id="promo_id" value="1"
                                               v-model="voucher.promo_id">
                                        <label class="custom-control-label" for="promo_id">Продажа с кэшбэком
                                            Ростуризма</label>
                                    </div>
                                </b-form-group>
                            </template>
                            <template v-else>
                                <p v-if="!!voucher.promo_id">
                                    <strong>Продажа с кэшбэком Ростуризма</strong>
                                </p>
                            </template>


                            <template v-if="can_view_quota">
                                <b-form-group
                                    description="Данная путевка не является реальной, а создана исключительно для резервирования мест на перспективу">
                                    <div class="custom-control custom-checkbox custom-control-inline">
                                        <input type="checkbox" class="custom-control-input" id="is_quota" value="1"
                                               v-model="voucher.is_quota">
                                        <label class="custom-control-label" for="is_quota">Это квота</label>
                                    </div>
                                </b-form-group>
                            </template>

                            <template v-if="canSmSetQuota(voucher)">
                                canSmSetQuota(voucher)<br>
                            </template>

                            <template v-if="canSmResetQuota(voucher)">
                                canSmResetQuota(voucher)<br>
                            </template>

                            <template v-if="canSmDirectPay(voucher)">
                                canSmDirectPay(voucher)<br>
                            </template>

                            <template v-if="canSmDirectPayMeet(voucher)">
                                canSmDirectPayMeet(voucher)<br>
                            </template>

                            <template v-if="smIsQuotaFlag(voucher)">
                                smIsQuotaFlag(voucher)<br>
                            </template>

                            <template v-if="smIsNotQuotaFlag(voucher)">
                                smIsNotQuotaFlag(voucher)<br>
                            </template>

                            <template v-if="smIsDirectPayment(voucher)">
                                smIsDirectPayment(voucher)<br>
                            </template>

                            <template v-if="smNotDirectPayment(voucher)">
                                smNotDirectPayment(voucher)<br>
                            </template>

                        </b-card-body>


                    </b-collapse>
                </b-card>


                <b-card no-body>
                    <div slot="header">
                        <strong>Заселение</strong>
                        <div class="card-header-actions">
                            <b-link class="card-header-action btn-minimize" v-b-toggle.collapse_places>
                                <i class="icon-arrow-up"></i>
                            </b-link>
                        </div>
                    </div>
                    <b-collapse id="collapse_places" visible v-model="show_places">
                        <b-card-body v-if="canEditSettlement(voucher)">
                            <div class="row">
                                <b-col sm="12">
                                    <b-form-group
                                        label="Город"
                                        :state="!!voucher.t_city_id"
                                    >
                                        <v-select
                                            v-model="voucher.t_city_id"
                                            :options="cities"
                                            placeholder="Выберите город"
                                            label="title"
                                            :reduce="x=>x.id"
                                            name="city_id"
                                            :class="!!voucher.t_city_id?'':'is-invalid'"
                                            @input="onChangeCity"
                                        ></v-select>
                                    </b-form-group>

                                </b-col>
                            </div>
                            <div class="row" v-if="isHotelsLoaded() && voucher.t_city_id">
                                <b-col sm="12">
                                    <b-form-group
                                        label="Объект размещения"
                                        :state="!!voucher.t_obj_items_id"
                                    >
                                        <v-select
                                            v-model="voucher.t_obj_items_id"
                                            :options="hotels"
                                            placeholder="Выберите объект"
                                            label="title"
                                            :class="voucher.t_obj_items_id?'':'is-invalid'"
                                            :reduce="x=>x.id"
                                            @input="onChangeHotel"
                                            :state="!!voucher.t_obj_items_id"
                                        ></v-select>
                                    </b-form-group>

                                </b-col>
                            </div>

                            <!--                             isRoomsLoaded() {{isRoomsLoaded() }} <br>-->
                            <!--                             isHotelLoaded() {{isHotelLoaded() }} <br>-->
                            <!--                             voucher.t_obj_items_id {{voucher.t_obj_items_id }} <br>-->
                            <!--                             voucher.t_city_id {{voucher.t_city_id }} <br>-->
                            <!--                             this.rooms {{this.rooms }} <br>-->


                            <div class="row"
                                 v-if="isRoomsLoaded() && isHotelLoaded() && voucher.t_obj_items_id && voucher.t_city_id">
                                <b-col sm="8">
                                    <b-form-group
                                        label="Номер"
                                        :state="!!voucher.t_city_id"
                                    >
                                        <b-form-select
                                            :plain="true"
                                            :options="rooms"
                                            v-model="voucher.t_obj_rooms_id"
                                            value-field="id"
                                            text-field="title"
                                            @change="onChangeRoom"
                                            :state="!!voucher.t_city_id"
                                        >
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <b-form-group
                                        label="Бронировать">
                                        <b-button id='m_only_number' variant="outline-primary"
                                                  :pressed.sync="voucher.m_only_number"> {{voucher.m_only_number ? 'весь номер целиком' : 'места по-одному'}}
                                        </b-button>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12">
                                    <template v-if="room && room.m_one_full">в описании номера указано: бронируется весь
                                        номер<br></template>
                                    <template v-if="room && !room.m_one_full">в описании номера указано: можно
                                        бронировать места по-одному<br></template>
                                    расчетный час {{ hotel.time_check_payment }}<br>
                                </b-col>
                            </div>

                            <div class="row">
                                <b-col sm="3">
                                    <b-form-group label="Дата заезда" :description="getCheckInDateTime">
                                        <v-date-picker
                                            id="date_begin_iso"
                                            v-model='_date_begin_iso'
                                            :state="validateState('date_begin_iso')"
                                            :attributes="datepicker_attributes"
                                            v-validate="{required:true}"
                                            @input="onChangeDates(2)"
                                        >
                                            <b-form-input
                                                type="text"
                                                id="date_begin_iso_input"
                                                slot-scope="{ inputProps, inputEvents, isDragging }"
                                                class="form-control form-date-picker"
                                                readonly
                                                :state="validateState('date_begin_iso')"
                                                v-bind="inputProps"
                                                v-on="inputEvents"/>
                                        </v-date-picker>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="6">
                                    <b-form-group label="Количество дней"
                                                  :description="'длительность путевки ' + $tc('day', days)">
                                        <b-button type="submit" variant="primary" @click="days=2"> 2</b-button> &nbsp;
                                        <b-button type="submit" variant="primary" @click="days=3"> 3</b-button> &nbsp;
                                        <b-button type="submit" variant="primary" @click="days=10"> 10</b-button>
                                        &nbsp;
                                        <b-button type="submit" variant="primary" @click="days=12"> 12</b-button>
                                        &nbsp;
                                        <b-button type="submit" variant="primary" @click="days=14"> 14</b-button>
                                        &nbsp;
                                        <b-button type="submit" variant="primary" @click="days=21"> 21</b-button>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                    <b-form-group label="Дата выезда" :description="getCheckOutDateTime">
                                        <v-date-picker
                                            id="date_end_iso"
                                            v-model='_date_end_iso'
                                            :state="validateState('date_end_iso')"
                                            :attributes="datepicker_attributes"
                                            @input="onChangeDates(3)"
                                        >
                                            <b-form-input
                                                type="text"
                                                id="date_end_iso_input"
                                                slot-scope="{ inputProps, inputEvents, isDragging }"
                                                class="form-control form-date-picker"
                                                readonly
                                                :state="validateState('date_end_iso')"
                                                v-bind="inputProps"
                                                v-on="inputEvents"/>
                                        </v-date-picker>
                                    </b-form-group>
                                </b-col>
                            </div>
                            <div class="row">
                                <b-col>
                                    <b-button variant="primary" @click="onPlacesCheck()"><i
                                        class="fa fa-check-circle-o"></i> Проверка наличия мест
                                    </b-button>
                                    &nbsp;<template v-if="0 && is_admin">
                                    <b-button variant="primary" @click="onClickRequest()"><i class="fa fa-send"></i>
                                        Запрос наличия мест
                                    </b-button>&nbsp;
                                    <b-button variant="primary" @click="onTryBook()"><i class="fa fa-send"></i> Попытка
                                        бронирования
                                    </b-button>
                                </template>
                                </b-col>
                            </div>

                            <div class="row" v-if="availabilityText">
                                <b-col>
                                    <br>
                                    <div v-html="availabilityText"></div>
                                    <ul>
                                        <li v-for="room in availability.rooms" v-if="room.m">{{room.title}} &nbsp; <span
                                            style="color:#BBBBBB">({{room.m}} номеров) </span> &nbsp;
                                            <template v-if="!room.m_disabled">
                                                <a href="#"
                                                   @click.prevent="()=>{voucher.t_obj_rooms_id=room.id; resetPersons(false)}">выбрать</a>
                                            </template>
                                            <template v-else>
                                                номер помечен как неактивный
                                            </template>
                                        </li>
                                    </ul>
                                </b-col>
                            </div>

                        </b-card-body>
                        <b-card-body v-if="!canEditSettlement(voucher)">

                            Город: <strong>{{ voucher.city_title }} (#{{ voucher.t_city_id }})</strong><br>
                            Объект : <strong>{{ voucher.hotel_title }} (#{{ voucher.t_obj_items_id }})</strong><br>
                            Номер: <strong>{{ voucher.room_title }} (#{{ voucher.t_obj_rooms_id }})</strong><br>
                            Бронируется: <strong>{{voucher.m_only_number ? 'весь номер целиком' : 'места по-одному'}}</strong><br>
                            Дата заезда: <strong>{{ formatDate(_date_begin_iso) }}</strong><br>
                            Дата выезда: <strong>{{ formatDate(_date_end_iso) }}</strong><br>

                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body v-if="is_manager_or_buh  || is_agent_or_agency || is_admin">
                    <div slot="header">
                        <strong>Счет от системы к оплате
                            <template v-if="is_admin"> (для агента)</template>
                        </strong>
                        <div class="card-header-actions">
                            <b-link class="card-header-action btn-minimize" v-b-toggle.collapse_booking>
                                <i class="icon-arrow-up"></i>
                            </b-link>
                        </div>
                    </div>
                    <b-collapse id="collapse_booking" visible v-model="show_booking">
                        <b-card-body>
                            <div class=" table-responsive">
                                <table class="table table-bordered table-sm table-hover table-striped"
                                       v-if="is_voucher_bookings">
                                    <tr>
                                        <th>№ счета</th>
                                        <th>дата счета</th>
                                        <th>сумма счета</th>
                                        <th>вознаграждние</th>
                                        <th>статус</th>
                                        <th></th>
                                    </tr>
                                    <tr v-for="b in voucher.bookings">
                                        <template v-if="b.prebook">
                                            <td colspan="3">Предварительное бронирование до {{
                                                printDate(b.wait_invoice_date) }}
                                            </td>
                                            <td>
                                                <template v-if="is_manager_or_buh || is_agent_plus || is_admin">
                                                    {{getBookingStatusNameAgent(b.status)}}
                                                </template>
                                                <template v-else>
                                                    {{getBookingStatusName(b.status)}}
                                                </template>
                                            </td>
                                        </template>
                                        <template v-else>
                                            <template v-if="b.direct_payment">
                                                <td colspan="4">оплата в кассу объекта</td>
                                            </template>
                                            <template v-else>
                                                <td>#{{b.bill_number}}</td>
                                                <td>{{printDate(b.bill_date)}}</td>
                                                <td class="text-right">{{ formatPriceKop(b.bill_value)  }}</td>
                                                <td class="text-right">
                                                    <template  v-if="fee_changed(b)">
                                                        <b class="text-danger">
                                                            {{ formatPriceKop(calc_fee_amount(b))  }}<br>
                                                            {{ calc_fee_pc(b) }}% Изменено!!!
                                                        </b>
                                                    </template>
                                                    <template  v-else>
                                                        {{ formatPriceKop(calc_fee_amount(b))  }}<br>
                                                        {{ calc_fee_pc(b) }}%
                                                    </template>

                                                </td>
                                            </template>
                                            <td>
                                                {{getBookingStatusName(b.status)}}
                                                <template v-if="bookingBillToPay(b)">
                                                    <template v-if="b.bill_redemption_date">
                                                        <br/>оплатить до {{printDate(b.bill_redemption_date)}}
                                                    </template>
                                                </template>
                                            </td>
                                        </template>
                                        <td>
                                            <template v-if="!b.prebook">
                                                <b-button class="btn btn-ghost-success btn-sm" @click="printBooking(b)">
                                                    <i class="fa fa-print"></i></b-button>
                                            </template>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body v-if="is_manager_or_buh || is_admin || is_agent_plus">
                    <div slot="header">
                        <strong>Бронирование
                            <template v-if="is_admin"> (для менеджера)</template>
                        </strong>
                        <div class="card-header-actions">
                            <b-link class="card-header-action btn-minimize" v-b-toggle.collapse_booking>
                                <i class="icon-arrow-up"></i>
                            </b-link>
                        </div>
                    </div>
                    <b-collapse id="collapse_booking" visible v-model="show_booking">
                        <b-card-body>
                            <div class="table-responsive">
                                <table class="table table-bordered table-sm table-hover table-striped"
                                       v-if="is_voucher_bookings">
                                    <tr>
                                        <th><a @click.prevent="showBookingId=b.id">#</a></th>
                                        <th>счет</th>
                                        <th>сумма счета</th>
                                        <th>сумма к оплате</th>
                                        <th>статус</th>
                                        <th colspan="3">операции</th>
                                    </tr>
                                    <tr v-for="b in voucher.bookings">
                                        <td>#{{b.id}}</td>
                                        <template v-if="b.prebook">
                                            <td colspan="4">Предварительное бронирование до {{
                                                printDate(b.wait_invoice_date) }}
                                            </td>
                                        </template>
                                        <template v-else>
                                            <td class="nobr">
                                                <template v-if="b.direct_payment">
                                                    оплата в кассу объекта
                                                </template>
                                                <template v-else>
                                                    <template v-if="b.invoice_number">
                                                        {{b.invoice_number}} от {{printDate(b.invoice_date)}}
                                                        <template v-if="b.booker_id">
                                                            <br/>{{b.booker_id==1?'П/К':''}} {{b.external_id}}
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        ожидание счета<br/>
                                                        до {{printDate(b.wait_invoice_date)}}
                                                    </template>
                                                </template>
                                            </td>
                                            <td class="text-right">{{formatPriceKop(b.invoice_value) }}</td>
                                            <td class="text-right">{{formatPriceKop(b.to_pay_value)}}</td>
                                            <td>{{getBookingStatusName(b.status)}}
                                                <template v-if="bookingInvoiceToPay(b)">
                                                    <template v-if="b.redemption_date">
                                                        <br/>оплатить до {{printDate(b.redemption_date)}}
                                                    </template>
                                                </template>
                                            </td>
                                        </template>
                                        <td>
                                            <b-button class="btn btn-ghost-primary btn-sm" @click="showBookingId=b.id">
                                                <i class="fa fa-eye"></i></b-button>
                                            <template v-if="b.status!==CONSTANTS.BOOKING_STATUS_CANCELLED">
                                                <b-button class="btn btn-ghost-danger btn-sm"
                                                          @click="onCancelBooking(b)"><i class="fa fa-times"></i>
                                                </b-button>
                                                <b-button class="btn btn-ghost-primary btn-sm"
                                                          :to="{ path: bookingPage(b.id) }"><i class="fa fa-edit"></i>
                                                </b-button>
                                            </template>
                                            <template v-else>
                                                <b-button class="btn btn-ghost-secondary btn-sm" disabled><i
                                                    class="fa fa-times"></i></b-button>
                                                <b-button class="btn btn-ghost-secondary btn-sm" disabled><i
                                                    class="fa fa-edit"></i></b-button>
                                            </template>
                                            <template v-if="b.booker_id && b.external_id">
                                                <b-button class="btn btn-ghost-primary btn-sm"
                                                          :to="{ path: bookingPageEx(b.id) }"><i
                                                    class="fa fa-external-link"></i></b-button>
                                            </template>
                                            <template v-if="bookingInvoicePayed">
                                                <b-button class="btn btn-ghost-secondary btn-sm" :disabled="true"><i
                                                    class="fa fa-money"></i></b-button>
                                            </template>
                                            <template v-else-if="bookingBillPayed">
                                                <b-button class="btn btn-ghost-success btn-sm" @click="billPayed(b)"><i
                                                    class="fa fa-money"></i></b-button>
                                            </template>
                                            <template v-else>
                                                <b-button class="btn btn-ghost-success btn-sm" @click="invoicePayed(b)">
                                                    <i class="fa fa-money"></i></b-button>
                                            </template>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <button class="btn btn-sm btn-primary" @click="showCreateBookingModal=true"><i
                                class="fa fa-plus"></i> Добавить ранее созданную бронь
                            </button>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body v-if="is_agent_or_agency || is_admin">
                    <div slot="header">
                        <strong>Документы для клиента</strong>
                        <div class="card-header-actions">
                            <b-link class="card-header-action btn-minimize" v-b-toggle.collapse_client_files>
                                <i class="icon-arrow-up"></i>
                            </b-link>
                        </div>
                    </div>
                    <b-collapse id="collapse_client_files" visible v-model="show_client_files">
                        <b-card-body>
                            <div class="table-responsive">
                                <table class="table table-bordered table-sm table-hover table-striped  table-responsive"
                                       v-if="is_voucher_files">
                                    <tr>
                                        <th>дата</th>
                                        <th>документ</th>
                                        <th>статус</th>
                                    </tr>
                                    <tr v-for="f in voucher.files">
                                        <td v-html="printDateTime(f.created_at, false, true, false)"></td>
                                        <td><a :href="f.path" target="_blank">{{ f.orig_name }} (
                                            <template v-if="f.faximile">с факсимиле</template>
                                            <template v-else>без факсимиле</template>
                                            )</a></td>
                                        <td>
                                            <template v-if="f.cancelled">отменен</template>
                                            <template v-else>действует</template>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div class="btn-group">
                                <button class="btn btn-primary" @click="onCreateDocuments()"><i class="fa fa-page4"></i>
                                    Создать комплет документов
                                </button>
                                <b-button variant="ghost-primary" id="reload-button" @click="reloadVoucher()"><i
                                    class="fa fa-refresh"></i>&nbsp;
                                </b-button>
                            </div>
                            <p><small>Если комплект документов уже создан, то они будут отменены и вместо них будут
                                созданы новые документы. После создания документов обновите.</small></p>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body v-if="is_agent_or_agency || is_admin">
                    <div slot="header">
                        <strong>Билеты</strong>
                        <div class="card-header-actions">
                            <b-link class="card-header-action btn-minimize" v-b-toggle.collapse_tickets>
                                <i class="icon-arrow-up"></i>
                            </b-link>
                        </div>
                    </div>
                    <b-collapse id="collapse_tickets" visible v-model="show_tickets">
                        <b-card-body>
                            <div class="table-responsive">
                                <table class="table table-bordered table-sm table-hover table-striped  table-responsive"
                                       v-if="is_tickets">
                                    <tr>
                                        <th>№</th>
                                        <th>турист</th>
                                        <th>билет</th>
                                        <th>цена</th>
                                        <th>статус</th>
                                    </tr>
                                    <tr v-for="(t,i) in tickets">
                                        <td>{{i+1}}</td>
                                        <td>
                                            <template v-if="getGuestById(t.guest_id)">
                                                {{ formatGuest(getGuestById(t.guest_id)) }}
                                            </template>
                                        </td>
                                        <td>
                                            {{ticketType(t)}}<br>
                                            <template v-if="t.departure_point || t.departure_at">
                                                Отправление
                                                <template v-if="t.departure_point">
                                                    из {{t.departure_point}}
                                                </template>
                                                <template v-if="t.departure_at">
                                                    {{printDate(t.departure_at)}}
                                                </template>
                                                <br>
                                            </template>
                                            <template v-if="t.arrival_point || t.arrival_at">
                                                Прибытие
                                                <template v-if="t.arrival_point">
                                                    в {{t.arrival_point}}
                                                </template>
                                                <template v-if="t.arrival_at">
                                                    {{printDate(t.arrival_at)}}
                                                </template>
                                                <br>
                                            </template>
                                            <template v-if="t.number">
                                                Рейс {{t.number}}
                                                <br>
                                            </template>
                                            <template v-if="t.comment">
                                                <i>{{t.comment}}</i>
                                            </template>
                                        </td>
                                        <td>
                                            {{formatPriceKop(t.price)}}
                                        </td>
                                        <td>
                                            <template v-if="t.disabled">
                                                отменен
                                            </template>
                                            <template v-else>
                                                <!--                                                <b-button class="btn btn-ghost-primary btn-sm" @click="showShowTicketEditDialog=t.id"><i class="fa fa-eye"></i></b-button>-->
                                                <b-button class="btn btn-ghost-primary btn-sm"
                                                          @click="showShowTicketEditDialog=t.id"><i
                                                    class="fa fa-edit"></i></b-button>
                                                <b-button class="btn btn-ghost-danger btn-sm"
                                                          @click="onCancelTicket(t)"><i class="fa fa-times"></i>
                                                </b-button>
                                            </template>
                                        </td>
                                        <!--                                        <td v-html="printDateTime(f.created_at, false, true, false)"></td>-->
                                        <!--                                        <td><a :href="f.path" target="_blank">{{ f.orig_name }} (<template v-if="f.faximile">с факсимиле</template><template v-else>без факсимиле</template>)</a> </td>-->
                                        <!--                                        <td><template v-if="f.cancelled">отменен</template><template v-else>действует</template></td>-->
                                    </tr>
                                    <tr>
                                        <td colspan="3">Итого</td>
                                        <td>
                                            {{ formatPriceKop(tickets_total) }}
                                        </td>
                                        <td>
                                        </td>
                                    </tr>

                                </table>
                            </div>
                            <div class="btn-group">
                                <button class="btn btn-primary" @click="onCreateTicket()"><i class="fa fa-page4"></i>
                                    Добавить билет
                                </button>
                            </div>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body v-if="canSmShowVoucherTelecalls() && isTelecallsLoaded()">
                    <div slot="header">
                        <strong>Звонки</strong>
                        <div class="card-header-actions">
                            <b-link class="card-header-action btn-minimize" v-b-toggle.collapse_telecalls>
                                <i class="icon-arrow-up"></i>
                            </b-link>
                        </div>
                    </div>
                    <b-collapse id="collapse_telecalls" visible v-model="show_telecalls">
                        <b-card-body>
                            <table class="table table-bordered table-sm table-hover table-striped  table-responsive"
                                   v-if="isTelecallsLoaded()">
                                <tr>
                                    <th>#</th>
                                    <th>начало/завершение</th>
                                    <th>внешний номер</th>
                                    <th>менеджер</th>
                                    <th><i class="icon-social-youtube"></i></th>
                                </tr>
                                <tr v-for="t in telecalls">
                                    <td>#{{t.id}}</td>
                                    <td>
                                        <span class="nobr" v-html="printTimeDate(t.created_at)"
                                              v-if="!is(t.started_at) && !is(t.stopped_at)"></span>
                                        <span class="nobr" v-html="printTimeDate(t.started_at)"
                                              v-if="is(t.started_at)"></span>
                                        <span class="nobr" v-html="printTimeDate(t.stopped_at)"
                                              v-if="is(t.stopped_at)"></span>
                                    </td>
                                    <td>
                                        {{ CONSTANTS.TELEPHONY_TYPE_NAMES[t.type] }}<br>
                                        <a :href="'tel:'+t.phone_number">{{t.phone_number}}</a>
                                    </td>
                                    <td>
                                        <span v-if="is(t.user_id)">
                                            (#{{t.user_id}}) {{t.full_name}} <a :href="'tel:'+t.telephony_number">{{t.telephony_number}}</a>
                                        </span>
                                    </td>
                                    <td>
                                        <span v-if="is(t.record)"><a :href="t.record" target="_blank"><i
                                            class="icon-social-youtube"></i></a></span>
                                        <span v-if="!is(t.record)">
                                            {{ CONSTANTS.TELEPHONY_EVENTS_NAMES[t.event_type] }} {{ t.ring_duration }}
                                        </span>
                                    </td>
                                </tr>
                            </table>
                        </b-card-body>
                    </b-collapse>
                </b-card>
            </b-col>
            <b-col md="6">

                <b-card no-body v-if="(is_agent_or_agency || is_admin)">
                    <div slot="header">
                        <strong>Источник поступления</strong>
                        <div class="card-header-actions">
                            <b-link class="card-header-action btn-minimize" v-b-toggle.collapse_source>
                                <i class="icon-arrow-up"></i>
                            </b-link>
                        </div>
                    </div>
                    <b-collapse id="collapse_source" visible v-model="show_source">
                        <b-card-body>
                            <template v-if="voucher.source">
                                <template v-if="voucher.source.domain">Дoмен: {{ voucher.source.domain }}<br></template>
                                <template v-if="voucher.source.url">URL: <a :href="voucher.source.url" target="_blank">{{ voucher.source.url }}</a><br></template>
                                <template v-if="voucher.source.referrer">Пришли с: <a :href="voucher.source.referrer" target="_blank">{{ voucher.source.referrer }}</a><br></template>
                                <template v-if="voucher.source.city_id">Город: {{ voucher.source.city.title }} (#{{ voucher.source.city_id }})<br></template>
                                <template v-if="voucher.source.hotel_id">Объект: {{ voucher.source.hotel.title }} (#{{ voucher.source.hotel_id }})<br></template>
                                <template v-if="voucher.source.room_id">Номер: {{ voucher.source.room.title }} (#{{ voucher.source.room_id }})<br></template>
                                <template v-if="voucher.source.program_id">Программа: {{ voucher.source.room.title }} (#{{ voucher.source.program_id }})<br></template>
                                <template v-if="voucher.source.uuid && (voucher.source.uuid!='00000000-0000-0000-0000-000000000000')">UUID: {{ voucher.source.uuid }}<br></template>
                            </template>
                            <template v-if="voucher.order">
                                Заявка: <a :href="$router.resolve({ path: '/agent/order/'+voucher.order_id }).href">#{{voucher.order_id}}</a><br/>
                                <template v-if="voucher.order.t_city_id">Город: {{ voucher.order.city.title }} (#{{ voucher.order.t_city_id }}) .<br></template>
                                <template v-if="voucher.order.t_city_id_correct">Город: {{ voucher.order.city_correct.title }} (#{{ voucher.order.t_city_id_correct }})<br></template>
                                <template v-if="voucher.order.t_obj_items_id">Объект: {{ voucher.order.hotel.title }} (#{{ voucher.order.hotel.title }}) .<br></template>
                                <template v-if="voucher.order.t_obj_items_id_correct">Объект: {{ voucher.order.hotel_correct.title }} (#{{ voucher.order.t_obj_items_id_correct }})<br></template>
                                <template v-if="voucher.order.t_obj_rooms_id">Номер: {{ voucher.order.room.title }} (#{{ voucher.order.t_obj_rooms_id }}) .<br></template>
                                <template v-if="voucher.order.t_obj_rooms_id_correct">Номер: {{ voucher.order.room_correct.title }} (#{{ voucher.order.t_obj_rooms_id_correct }})<br></template>
                                <template v-if="voucher.order.t_obj_tariff_id">Тариф: {{ voucher.order.program.title }} (#{{ voucher.order.program.title }}) .<br></template>
                                <template v-if="voucher.order.t_obj_tariff_id_correct">Тариф: {{ voucher.order.program_correct.title }} (#{{ voucher.order.t_obj_tariff_id_correct }})<br></template>
                                <template v-if="voucher.order.other_text">Комментарий: (#{{ voucher.order.other_text }})<br></template>
                                <template v-if="voucher.order.other_text_correct  && (voucher.order.other_text_correct!=voucher.order.other_text)">Комментарий: {{ voucher.order.other_text_correct }}<br></template>
                                <template v-if="voucher.order.url_referer_form">Ссылка: <a :href="voucher.order.url_referer_form" target="_blank">{{ voucher.order.url_referer_form }}</a><br></template>
                                <template v-if="voucher.order.url_referer_order && (voucher.order.url_referer_order!=voucher.order.url_referer_form)">Ссылка: <a :href="voucher.order.url_referer_order" target="_blank">{{ voucher.order.url_referer_order }}</a><br></template>
                            </template>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body>
                    <div slot="header">
                        <strong>Заказчик</strong>
                        <div class="card-header-actions">
                            <b-link class="card-header-action btn-minimize" v-b-toggle.collapse_contacts>
                                <i class="icon-arrow-up"></i>
                            </b-link>
                        </div>
                    </div>
                    <b-collapse id="collapse_contacts" visible v-model="show_contacts">
                        <b-card-body>
                            <template v-if="voucher.customer_id">
                                {{ this.customerTitle(voucher.customer) }}<br>
                                <small>{{ this.customerSubtitle(voucher.customer) }}</small><br>
                                <div class="form-group">
                                    <button class="btn btn-sm btn-mg btn-primary"
                                            @click="showShowCustomerDialog=voucher.customer_id"
                                            v-if="canShowCustomer(voucher.customer)">Посмотреть заказчика
                                    </button>
                                    <button class="btn btn-sm btn-mg btn-primary"
                                            @click="showEditCustomerDialog=voucher.customer_id"
                                            v-if="canEditCustomer(voucher.customer)">Редактировать заказчика
                                    </button>
                                    <button class="btn btn-sm btn-mg btn-primary" @click="onSelectCustomer">Выбрать
                                        заказчика
                                    </button>
                                </div>
                            </template>
                            <template v-else>
                                <div>
                                    <button class="btn btn-sm btn-primary" @click="onSelectCustomer">Выбрать заказчика
                                    </button>
                                </div>
                            </template>

                            <template v-if="!voucher.customer_id">
                                <br><small>
                                Заказчика нужно создавать ОБЯЗАТЕЛЬНО если он организация, что бы корректно печтались
                                документы. в остальных случаях создание заказчика
                                пока не обязательно, но в ближайшее время станет обязательным.
                            </small>
                            </template>

                        </b-card-body>

                        <b-card-body v-if="canEditClient(voucher) && !voucher.customer_id">
                            <div class="row">
                                <b-col sm="9">
                                    <b-form-group label="ФИО Заказчика">
                                        <b-form-input type="text"
                                                      v-model="voucher.contact_name"
                                                      v-validate="{max:200,required:true}"
                                                      id="contact_name"
                                                      name="contact_name"
                                                      data-vv-as="'ФИО Заказчика'"
                                                      :state="validateState('contact_name')"
                                                      aria-describedby="contact_name_feedback"
                                        ></b-form-input>
                                        <b-form-invalid-feedback id="contact_name_feedback"> {{
                                            veeErrors.first('contact_name') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                    <b-form-group>
                                        <label for="is_org">Юридическое лицо</label><br>
                                        <c-switch id="is_org" class="mx-1" color="primary" label variant="pill"
                                                  v-model="voucher.is_org" v-bind="labelIcon"/>
                                    </b-form-group>
                                </b-col>
                            </div>
                            <b-form-group label="Контактный e-mail">
                                <b-form-input type="text" id="contact_email"
                                              v-model="voucher.contact_email"
                                              v-validate="{max:100,email:true}"
                                              name="contact_email"
                                              data-vv-as="'Контактный e-mail'"
                                              :state="validateState('contact_email')"
                                              aria-describedby="contact_email_feedback"
                                ></b-form-input>
                                <b-form-invalid-feedback id="contact_email_feedback"> {{
                                    veeErrors.first('contact_email') }}
                                </b-form-invalid-feedback>

                            </b-form-group>
                            <b-form-group
                                :state="validateScopedState('orderform', 'city_of_origin')"
                                label="Город проживания"
                                :invalid-feedback="veeErrors.first('orderform.city_of_origin')"
                            >
                                <city-input
                                    v-model="voucher.city_of_origin"
                                    id="city_of_origin"
                                    v-validate="{max:100}"
                                    data-vv-scope="orderform"
                                    name="city_of_origin"
                                    data-vv-as="'Город проживания'"
                                    :state="validateScopedState('orderform', 'city_of_origin')"
                                ></city-input>

                            </b-form-group>
                        </b-card-body>

                        <b-card-body v-if="canEditClient(voucher)">
                            <div class="row" v-if="isOrderLoaded()">
                                <b-col sm="12">
                                    <b-form-group>
                                        <p>Из заявки: {{order.phones}} {{order.phones_correct}}</p>
                                    </b-form-group>
                                </b-col>
                            </div>

                            <div class="row">
                                <b-col xs="6">
                                    <b-form-group>
                                        Телефонный номер
                                    </b-form-group>
                                </b-col>

                                <b-col xs="6">
                                    <b-form-group>
                                        Комментарий
                                    </b-form-group>
                                </b-col>
                            </div>
                            <div class="row" v-for="telenum in voucher.telenums" :key="telenum.id">
                                <b-col xs="6">
                                    <b-form-group>
                                        <span class="flex-form__item-inline-telenum" v-if="telenum.id"><a
                                            :href="'tel:'+telenum.number">{{ telenum.number }}</a></span>
                                        <b-form-input v-if="!telenum.id"
                                                      type="text" id="telenum_number"
                                                      v-model="telenum.number"
                                                      v-validate="{phone:true}"
                                                      name="telenum_number"
                                                      data-vv-as="'Номер телефона'"
                                                      :state="validateState('telenum_number')"
                                                      aria-describedby="telenum_number_feedback"
                                                      class="form-control-sm"
                                        ></b-form-input>
                                        <b-form-invalid-feedback id="telenum_number_feedback"> {{
                                            veeErrors.first('telenum_number') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>

                                <b-col xs="6">
                                    <b-form-group>
                                        <b-form-input type="text" id="telenum_info"
                                                      v-model="telenum.info"
                                                      v-validate="{max:200}"
                                                      name="telenum_info"
                                                      data-vv-as="'Комментарий'"
                                                      :state="validateState('telenum_info')"
                                                      aria-describedby="telenum_info_feedback"
                                                      class="form-control-sm"
                                        ></b-form-input>
                                        <b-form-invalid-feedback id="telenum_info_feedback"> {{ veeErrors.first('') }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                            </div>

                            <b-button id='add_telenum' variant="primary" @click="onAddPhone"><i class="fa fa-plus"></i>
                                Добавить телефонный номер
                            </b-button>
                        </b-card-body>
                        <b-card-body v-if="!canEditClient(voucher)">
                            <template v-if="voucher.contact_name">ФИО Заказчика: <strong>{{ voucher.contact_name
                                }}</strong><br></template>
                            <template v-else>ФИО Заказчика не указано<br></template>
                            <template v-if="voucher.city_of_origin">Город проживания: <strong>{{ voucher.city_of_origin
                                }}</strong><br></template>
                            <template v-if="canShowContacts(voucher)">
                                <template v-if="voucher.contact_email">Контактный e-mail: <strong><a
                                    :href="'mailto:'+voucher.contact_email">{{ voucher.contact_email }}</a></strong><br>
                                </template>
                                <!--template v-if="isTelenumsLoaded()"  v-for="telenum in telenums">
                                    Телефон: <a :href="'tel:'+telenum.number">{{ telenum.number }}</a> {{telenum.info}}<br>
                                </template-->
                                <template v-for="telenum in voucher.telenums">
                                    Телефон: <a :href="'tel:'+telenum.number">{{ telenum.number }}</a>
                                    {{telenum.info}}<br>
                                </template>
                                <template v-if="!voucher.is_org">
                                    Паспорт: <strong>{{voucher.passport_serial}} {{voucher.passport_number}} выдан {{
                                    printDate(_passport_date_issue) }} {{voucher.passport_issued}}</strong><br>
                                </template>
                                <template v-if="voucher.is_org">
                                    Организация: <strong>{{voucher.org_name}}</strong><br>
                                    ИНН/КПП: <strong>{{ voucher.org_inn }} {{ voucher.org_kpp }}</strong><br>
                                    Юр. Адрес: <strong>{{voucher.org_addr}}</strong><br>
                                </template>
                            </template>
                        </b-card-body>
                    </b-collapse>
                </b-card>

                <template v-if="!voucher.customer_id">
                    <b-card no-body v-if="voucher.is_org && canEditClient(voucher)">
                        <div slot="header">
                            <strong>Реквизиты юридического лица</strong>
                            <div class="card-header-actions">
                                <b-link class="card-header-action btn-minimize" v-b-toggle.collapse_orgreqreq>
                                    <i class="icon-arrow-up"></i>
                                </b-link>
                            </div>
                        </div>
                        <b-collapse id="collapse_orgreqreq" visible v-model="show_orgreq">
                            <b-card-body>
                                <b-form-group label="Наименование организации">
                                    <b-form-input type="text" id="org_name"
                                                  v-model="voucher.org_name"
                                                  v-validate="{max:500,required:true}"
                                                  name="org_name"
                                                  data-vv-as="'Наименование организации'"
                                                  :state="validateState('org_name')"
                                                  aria-describedby="org_name_feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="org_name"> {{ veeErrors.first('org_name') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                                <div class="row">
                                    <b-col sm="6">
                                        <b-form-group label="ИНН">
                                            <b-form-input type="text" id="org_inn"
                                                          v-model="voucher.org_inn"
                                                          v-validate="voucher.is_org ? {min:10,max:12,required:true,inn:true} : {}"
                                                          name="org_inn"
                                                          data-vv-as="'ИНН'"
                                                          :state="validateState('org_inn')"
                                                          aria-describedby="org_inn_feedback"
                                            ></b-form-input>
                                            <b-form-invalid-feedback id="org_inn"> {{ veeErrors.first('org_inn') }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="6">
                                        <b-form-group label="КПП">
                                            <b-form-input type="text" id="org_kpp"
                                                          v-model="voucher.org_kpp"
                                                          v-validate="voucher.is_org ? {min:9,max:9,kpp:true} : {}"
                                                          name="org_kpp"
                                                          data-vv-as="'КПП'"
                                                          :state="validateState('org_kpp')"
                                                          aria-describedby="org_kpp_feedback"
                                            ></b-form-input>
                                            <b-form-invalid-feedback id="org_kpp"> {{ veeErrors.first('org_kpp') }}
                                            </b-form-invalid-feedback>

                                        </b-form-group>
                                    </b-col>
                                </div>
                                <b-form-group label="Адрес организации">
                                    <b-form-input type="text" id="org_addr"
                                                  v-model="voucher.org_addr"
                                                  v-validate="{max:500,required:true}"
                                                  name="org_addr"
                                                  data-vv-as="'Адрес организации'"
                                                  :state="validateState('org_addr')"
                                                  aria-describedby="org_addr_feedback"
                                    ></b-form-input>
                                    <b-form-invalid-feedback id="org_addr"> {{ veeErrors.first('org_addr') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body v-if="!voucher.is_org && canEditClient(voucher)">
                        <div slot="header">
                            <strong>Реквизиты физического лица</strong>
                            <div class="card-header-actions">
                                <b-link class="card-header-action btn-minimize" v-b-toggle.collapse_requisites_fl>
                                    <i class="icon-arrow-up"></i>
                                </b-link>
                            </div>
                        </div>
                        <b-collapse id="collapse_requisites_fl" visible v-model="show_requisites">
                            <b-card-body>
                                <div class="row">
                                    <b-col sm="6">
                                        <b-form-group label="Серия паспорта">
                                            <b-form-input type="text" id="passport_serial"
                                                          v-model="voucher.passport_serial"
                                                          v-validate="{max:10}"
                                                          name="passport_serial"
                                                          :state="validateState('passport_serial')"
                                                          data-vv-as="'Серия паспорта'"
                                            ></b-form-input>
                                            <b-form-invalid-feedback id="passport_serial"> {{
                                                veeErrors.first('passport_serial') }}
                                            </b-form-invalid-feedback>

                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="6">
                                        <b-form-group label="Номер паспорта">
                                            <b-form-input type="text" id="passport_number"
                                                          v-model="voucher.passport_number"
                                                          v-validate="{max:10}"
                                                          name="passport_number"
                                                          data-vv-as="'Номер паспорта'"
                                                          :state="validateState('passport_number')"
                                            ></b-form-input>
                                            <b-form-invalid-feedback id="passport_number"> {{
                                                veeErrors.first('passport_number') }}
                                            </b-form-invalid-feedback>

                                        </b-form-group>
                                    </b-col>

                                    <b-col sm="6">
                                        <b-form-group label="Кем выдан паспорт">
                                            <b-form-input type="text" id="passport_issued"
                                                          v-model="voucher.passport_issued"
                                                          v-validate="{max:200}"
                                                          name="passport_issued"
                                                          data-vv-as="'Кем и когда выдан паспорт'"
                                                          :state="validateState('passport_issued')"
                                            ></b-form-input>
                                            <b-form-invalid-feedback id="passport_issued"> {{
                                                veeErrors.first('passport_issued') }}
                                            </b-form-invalid-feedback>

                                        </b-form-group>
                                    </b-col>

                                    <b-col sm="6">
                                        <b-form-group label="Дата выдачи паспорта">
                                            <b-input-group style="witdh:100%">
                                                <v-date-picker
                                                    id="passport_date_issue"
                                                    v-model='_passport_date_issue'
                                                    :state="validateState('passport_date_issue')"
                                                    :attributes="datepicker_attributes"
                                                >
                                                    <b-form-input
                                                        type="text"
                                                        id="passport_date_issue_input"
                                                        slot-scope="{ inputProps, inputEvents, isDragging }"
                                                        class="form-control form-date-picker"
                                                        readonly
                                                        :state="validateState('passport_date_issue')"
                                                        v-bind="inputProps"
                                                        v-on="inputEvents"/>

                                                </v-date-picker>
                                                <button type="button" class="btn btn-secondary"
                                                        @click.prevent="_passport_date_issue=null"><i
                                                    class="fa fa-times"></i></button>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </div>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </template>

                <b-card no-body v-if="showInvoiceBlock(voucher) && (is_agent_or_agency || is_admin)">
                    <div slot="header">
                        <strong>Счет заказчику</strong>
                        <div class="card-header-actions">
                            <b-link class="card-header-action btn-minimize" v-b-toggle.collapse_invoice>
                                <i class="icon-arrow-up"></i>
                            </b-link>
                        </div>
                    </div>

                    <b-collapse id="collapse_invoice" visible v-model="show_invoice">
                        <b-card-body>

                            <div class="row" v-if="canEditInvoice(voucher)">
                                <div class="col-sm-6">
                                    <b-form-group
                                        :state="validateState('ag_invoice_number')"
                                        label="Номер счета"
                                        description=''
                                        :invalid-feedback="veeErrors.first('ag_invoice_number')">
                                        <b-form-input type="text"
                                                      v-model="voucher.ag_invoice_number"
                                                      v-validate="{max:20}"
                                                      id="ag_invoice_number"
                                                      name="ag_invoice_number"
                                                      data-vv-as="'Номер счета'"
                                                      :state="validateState('ag_invoice_number')"
                                        ></b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col-sm-6">
                                    <b-form-group label="Дата счета"
                                                  :state="validateState('ag_invoice_date')"
                                                  :invalid-feedback="veeErrors.first('ag_invoice_date')"
                                    >
                                        <b-input-group style="witdh:100%">
                                            <v-date-picker
                                                id="ag_invoice_date"
                                                v-model='_ag_invoice_date'
                                                :state="validateState('ag_invoice_date')"
                                                :attributes="datepicker_attributes"
                                            >
                                                <b-form-input
                                                    type="text"
                                                    id="ag_invoice_date_input"
                                                    slot-scope="{ inputProps, inputEvents, isDragging }"
                                                    class="form-control form-date-picker"
                                                    readonly
                                                    :state="validateState('ag_invoice_date')"
                                                    v-bind="inputProps"
                                                    v-on="inputEvents"/>

                                            </v-date-picker>
                                            <button type="button" class="btn btn-secondary"
                                                    @click.prevent="_ag_invoice_date=null"><i class="fa fa-times"></i>
                                            </button>
                                        </b-input-group>
                                    </b-form-group>

                                </div>
                            </div>

                            <b-alert show variant="primary"
                                     v-if="!canEditInvoice(voucher) && voucher.ag_invoice_number">
                                Счет {{ voucher.ag_invoice_number }} от {{ printDate(_ag_invoice_date) }}
                            </b-alert>

                            <b-button variant="success" @click="onGetInvoice()" v-if="canGetInvoice(voucher)"><i
                                class="fa fa-arrow-right"></i> Получить номер счета
                            </b-button>

                        </b-card-body>
                    </b-collapse>
                </b-card>
                <b-card no-body>
                    <div slot="header">
                        <strong>Комментарии</strong>
                        <div class="card-header-actions">
                            <b-link class="card-header-action btn-minimize" v-b-toggle.collapse_comments>
                                <i class="icon-arrow-up"></i>
                            </b-link>
                        </div>
                    </div>
                    <b-collapse id="collapse_comments" visible v-model="show_comment">
                        <b-card-body>
                            <b-alert show variant="secondary" v-if="voucher.other_text_correct||voucher.comments_text"
                                     style="white-space: pre-wrap">{{ voucher.comments_text }}
                                <template v-if="voucher.other_text_correct"><b>{{"\n"+voucher.other_text_correct}}</b>
                                </template>
                            </b-alert>
                            <b-form-group
                                label="Добавить комментарий"
                                description="Комментарии добавляются сверху."
                            >
                                <b-form-textarea type="text"
                                                 v-model="voucher.add_comments_text"
                                                 v-validate="{max:50000}"
                                                 :id="'comments_text'"
                                                 :name="'comments_text'"
                                                 data-vv-as="Комментарий менеджера"
                                                 :state="validateState('comments_text')"
                                ></b-form-textarea>
                            </b-form-group>

                            <b-form-group>
                                <b-button variant="success" id="save-button" @click="onApply()" v-if="canSave(voucher)">
                                    <i class="fa fa-save"></i>&nbsp;Сохранить
                                </b-button>
                            </b-form-group>

                        </b-card-body>
                    </b-collapse>
                </b-card>

                <b-card no-body v-if="voucher.transfer_by_nsb || is_agent_or_agency">
                    <div slot="header">
                        <strong>Лист заезжающего</strong>
                        <div class="card-header-actions">
                            <b-link class="card-header-action btn-minimize" v-b-toggle.checkin_data>
                                <i class="icon-arrow-up"></i>
                            </b-link>
                        </div>
                    </div>

                    <b-collapse id="checkin_data" visible v-model="show_checkin_data">
                        <b-card-body>
                            <b-card-body>
                                <b-form-group label="Место встречи">
                                    <input type=text class="form-control"
                                           v-model="voucher.meeting_point"
                                           v-validate="{max:250}"
                                           :name="'meeting_point'"
                                    >
                                </b-form-group>

                                <b-form-group label="Телефоны встречаемого">
                                    <input type=text class="form-control"
                                           v-model="voucher.meeting_phones"
                                           v-validate="{max:100}"
                                           :name="'meeting_phones'"
                                    >
                                </b-form-group>

                                <b-form-group
                                    label="Комментарий к водителям"
                                >
                                    <b-form-textarea type="text"
                                                     v-model="voucher.comments_for_drive"
                                                     v-validate="{max:1000}"
                                                     :id="'comments_for_drive'"
                                                     :name="'comments_for_drive'"
                                                     data-vv-as="Комментарий к водителям"
                                                     :state="validateState('comments_for_drive')"
                                    ></b-form-textarea>
                                </b-form-group>

                                <div class="row">
                                    <div class="col col-sm-6">
                                        <b-form-group label="Дата встречи" description="локальная дата в месте встречи">
                                            <b-input-group style="witdh:100%">
                                                <v-date-picker
                                                    id="passport_date_issue"
                                                    v-model='_date_meeting_iso'
                                                    :attributes="datepicker_attributes"
                                                >
                                                    <b-form-input
                                                        type="text"
                                                        id="date_meeting_iso_input"
                                                        slot-scope="{ inputProps, inputEvents, isDragging }"
                                                        class="form-control form-date-picker"
                                                        readonly
                                                        v-bind="inputProps"
                                                        v-on="inputEvents"/>

                                                </v-date-picker>
                                                <button type="button" class="btn btn-secondary"
                                                        @click.prevent="voucher.date_meeting_iso=null"><i
                                                    class="fa fa-times"></i></button>
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                    <div class="col col-sm-6">
                                        <b-form-group label="Время встречи"
                                                      description="локальное время в месте встречи (ЧЧ:ММ)">
                                            <input class="form-control"
                                                   v-model="_meeting_time"
                                                   :name="'meeting_time'"
                                                   type="time"
                                            >
                                        </b-form-group>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col col-sm-4">
                                        <b-form-group label="Получить с клиента"
                                                      description="Сумма за путевку которую должен доплатить клиент встречающему">
                                            <input type=text class="form-control"
                                                   v-model.integer="_receive_payment"
                                                   v-validate="{min_value:0,decimal:2}"
                                                   :name="'receive_payment'"
                                            >
                                        </b-form-group>
                                    </div>
                                    <div class="col col-sm-4">
                                        <b-form-group label="Сумма за трансфер"
                                                      description="Сумма за трансфер которую должен оплатить клиент встречающему">
                                            <input type=text class="form-control"
                                                   v-model.integer="_summa_transfer"
                                                   v-validate="{min_value:0,decimal:2}"
                                                   :name="'summa_transfer'"
                                            >
                                        </b-form-group>
                                    </div>
                                    <div class="col col-sm-4">
                                        <b-form-group label="Сумма водителю" description="Сумма оплаты водителю">
                                            <input type=text class="form-control"
                                                   v-model.integer="_summa_driver"
                                                   v-validate="{min_value:0,decimal:2}"
                                                   :name="'summa_driver'"
                                            >
                                        </b-form-group>
                                    </div>
                                </div>

                                <b-form-group label="Водители">
                                    <b-form-select :plain="true"
                                                   :options="drivers"
                                                   v-model="voucher.driver_id"
                                                   value-field="id"
                                                   text-field="full_name"
                                    >
                                    </b-form-select>
                                </b-form-group>

                            </b-card-body>
                        </b-card-body>
                    </b-collapse>

                </b-card>

                <b-card no-body>
                    <div slot="header">
                        <strong>Платежи заказчика</strong>
                        <div class="card-header-actions">
                            <b-link class="card-header-action btn-minimize" v-b-toggle.client_payments>
                                <i class="icon-arrow-up"></i>
                            </b-link>
                        </div>
                    </div>

                    <b-collapse id="client_payments" visible v-model="show_client_payments">
                        <b-card-body>
                            <div class=" table-responsive">
                                <table class="table table-bordered table-sm table-hover table-striped"
                                       v-if="is_voucher_payments_ag">
                                    <tr>
                                        <th>№ счета</th>
                                        <th>дата счета</th>
                                        <th>№ платежа</th>
                                        <th>дата платежа</th>
                                        <th>сумма оплаты</th>
                                    </tr>
                                    <tr v-for="p in voucher.payments_ag">
                                        <td>{{p.invoice_number}}</td>
                                        <td>{{printDate(p.invoice_date)}}</td>
                                        <td>{{p.payment_number}}</td>
                                        <td>{{printDate(p.payment_date)}}</td>
                                        <td>{{p.summa}}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="4">Итого</td>
                                        <td>{{ formatPriceKop(voucher.total_payments_ag) }}</td>
                                    </tr>
                                </table>
                            </div>
                        </b-card-body>
                    </b-collapse>

                </b-card>

            </b-col>
        </div>

        <div class="row">
            <b-col>
                <b-card no-body>
                    <div slot="header">
                        <strong>Туристы</strong>
                        <div class="card-header-actions">
                            <b-link class="card-header-action btn-minimize" v-b-toggle.collapse_tourists>
                                <i class="icon-arrow-up"></i>
                            </b-link>
                        </div>
                    </div>
                    <b-collapse id="collapse_tourists" visible v-model="show_tourists">
                        <b-card-body>

                            <b-alert show variant="info">
                                Выбранный номер позволяет разместить {{ room_total_places }} человек
                                <span v-if="room_places_additionally">в том числе {{ room_places_additionally }} на дополнительных местах. </span>
                                <span v-if="infant_free">Младенцы до {{ infant_age }} лет размещаются без места бесплатно</span>
                                <span v-if="infant_disabled">Младенцы до {{ infant_age }} лет не допускаются</span>
                            </b-alert>

                            <table class="table table-bordered table-hover table-sm  table-responsive">
                                <tr>
                                    <th width="1%" v-if="canEditGuests(voucher)"></th>
                                    <th class="text-center" width="30%">ФИО</th>
                                    <th class="text-center" width="20%">документ, дата рожд, возраст, пол</th>
                                    <th class="text-center" width="30%">программа пребывания (лечения)</th>
                                    <th class="text-center" width="7%">сумма</th>
                                    <th class="text-center" width="7%">скидка</th>
                                    <th class="text-center" width="7%">предоплата</th>
                                    <th width="1%" v-if="canEditGuests(voucher)"></th>
                                </tr>
                                <tr v-for="(guest, i) in guests" :key="i" :class="person_valid(i)?'':'bg-warning'">
                                    <td v-if="canEditGuests(voucher)">
                                        <b-button variant="primary" @click="onEditGuest(i)"><i class="fa fa-edit"></i>
                                        </b-button>
                                    </td>
                                    <td>
                                        <b-form-group
                                            :state="validateState('surname'+i)"
                                            :invalid-feedback="veeErrors.first('surname'+i)"
                                        >
                                            <div class="input-group">
                                                <input
                                                    class="form-control form-control-sm"
                                                    v-validate="{required:true}"
                                                    :name="'surname'+i"
                                                    :state="validateState('surname'+i)"
                                                    data-vv-as="'Фамилия'"
                                                    placeholder="Фамилия"
                                                    style="min-width:100px;"
                                                    v-model="guest.surname">
                                                <input
                                                    class="form-control form-control-sm"
                                                    placeholder="Имя"
                                                    style="min-width:100px;"
                                                    v-model="guest.name_">
                                                <input
                                                    class="form-control form-control-sm"
                                                    placeholder="Отчество"
                                                    style="min-width:100px;"
                                                    v-model="guest.patro">
                                            </div>
                                        </b-form-group>
                                        <span v-if="guest.m_places_additionally">доп.место </span>
                                        <span v-if="guest.apply_social_discount">социальные скидки </span>
                                    </td>
                                    <td class="">{{ guest.document_type }} {{ printDate(guest.date_birthday_iso) }} {{
                                        formatAge(guest.age) }} {{guest.m_women?'Жен':'Муж'}}
                                    </td>
                                    <td>
                                        <b-form-select id="'program'+i"
                                                       :plain="true"
                                                       value-field="id"
                                                       v-validate="{required:true,min_value:1}"
                                                       v-model="guest.t_obj_tariff_id"
                                                       :data-vv-name="'program'+i"
                                                       data-vv-as="'Программа'"
                                                       :id="'program'+i"
                                                       :name="'program'+i"
                                                       :state="validateState('program'+i)"
                                                       class="form-control-sm"
                                                       v-if="isProgramsLoaded() && voucher.t_obj_items_id && voucher.t_city_id && canEditGuests(voucher)"
                                                       @input="onChangeProgram(i)"
                                        >
                                            <option value="0" disabled style="display: none;">выберите программу
                                            </option>
                                            <option v-for="program in programs" :key="program.id" :value="program.id">
                                                {{program.title}}
                                            </option>
                                        </b-form-select>
                                        <span
                                            v-if="isProgramsLoaded() && voucher.t_obj_items_id && voucher.t_city_id && !canEditGuests(voucher)">
                                            {{ getProgramTitleById(guest.t_obj_tariff_id) }}
                                        </span>
                                    </td>
                                    <td class="text-right">{{ formatPriceKop(guest.summa) }}</td>
                                    <td class="text-right">{{ formatPriceKop(guest.discount_value) }}</td>
                                    <td class="text-right">{{ formatPriceKop(guest.prepay_value) }}</td>
                                    <td v-if="canEditGuests(voucher)">
                                        <b-button variant="danger" @click="onDeleteBed(i)" :disabled="!can_delete_bed">
                                            <i class="fa fa-times"></i></b-button>
                                    </td>
                                </tr>
                                <tr>
                                    <th v-if="canEditGuests(voucher)"></th>
                                    <th colspan="3">Итого</th>
                                    <th class="text-right">{{ formatPriceKop(voucher.summa_full) }}</th>
                                    <th class="text-right">{{ formatPriceKop(voucher.summa_discount) }}</th>
                                    <th class="text-right">{{ formatPriceKop(voucher.summa_prev) }}</th>
                                    <th v-if="canEditGuests(voucher)">
                                        <b-button variant="primary" @click="onAddBed()" :disabled="!can_add_bed"
                                                  v-if="canEditGuests(voucher)"><i class="fa fa-plus"></i></b-button>
                                    </th>
                                </tr>
                                <tr v-if="is_tickets">
                                    <th v-if="canEditGuests(voucher)"></th>
                                    <th colspan="3">Билеты</th>
                                    <th class="text-right">{{ formatPriceKop(tickets_total) }}</th>
                                    <th></th>
                                    <th></th>
                                    <th v-if="canEditGuests(voucher)"></th>
                                </tr>
                                <tr>
                                    <th v-if="canEditGuests(voucher)"></th>
                                    <th colspan="3">К оплате</th>
                                    <th class="text-right">{{
                                        formatPriceKop(voucher.summa_full+tickets_total-voucher.summa_discount) }}
                                    </th>
                                    <th></th>
                                    <th></th>
                                    <th v-if="canEditGuests(voucher)"></th>
                                </tr>
                            </table>

                            <template v-if="(is_manager_or_buh || is_admin) && isHotelLoaded() ">
                                Вознаграждение объекта отдыха: {{ hotel.procent_ref_obj }}% ({{
                                formatPriceKop(voucher.summa_ref_obj) }}₽)<br>
                                Комиссионные «НСБ» с объекта: {{ hotel.sys_commission_obj_procent }}% ({{
                                formatPriceKop(voucher.sys_commission_obj_summa) }}₽) <br>
                                Комиссионные «НСБ» с компании: {{ voucher.company.procent_commission }}% ({{
                                formatPriceKop(voucher.sys_commission_company_summa) }}₽) <br>
                            </template>
                            <template v-if="voucher.procent_ref_agency">
                                Вознаграждение агентства: {{voucher.procent_ref_agency}}% ({{
                                formatPriceKop(voucher.summa_ref_agency) }}₽)<br>
                            </template>

                        </b-card-body>
                    </b-collapse>
                </b-card>
            </b-col>

        </div>

        <div class="row">
            <b-col>
                <b-card no-body v-if="isDiscountsLoaded()">
                    <div slot="header">
                        <strong>Скидки</strong>
                        <div class="card-header-actions">
                            <b-link class="card-header-action btn-minimize" v-b-toggle.collapse_discounts>
                                <i class="icon-arrow-up"></i>
                            </b-link>
                        </div>
                    </div>
                    <b-collapse id="collapse_discounts" visible v-model="show_discounts">
                        <b-card-body>

                            У выбранного объекта отдыха имеется {{ discounts.length }} предложений скидок

                            <table class='table table-bordered table-hover table-sm  table-responsive'>
                                <tr>
                                    <th rowspan="2" class="center">№</th>
                                    <th rowspan="2" class="center">Название и условия</th>
                                    <th colspan="2" class="center">Период продажи</th>
                                    <th colspan="2" class="center">Период заезда</th>
                                    <th colspan="3" class="center">Скидка</th>
                                    <th rowspan="2" class="center">Применить</th>
                                </tr>
                                <tr>
                                    <th class="center">Дата начала</th>
                                    <th class="center">Дата окончания</th>
                                    <th class="center">Дата заезда</th>
                                    <th class="center">Дата выезда</th>
                                    <th class="center">%</th>
                                    <th class="center">сумма</th>
                                    <th class="center">дней</th>
                                </tr>
                                <tr v-for="discount in discounts" v-bind:key="discount.id">
                                    <td class="center">{{ discount.id }}</td>
                                    <td class="center">
                                        <h6>{{ discount.title }}
                                            <template v-if="discount.social"> (социальная)</template>
                                        </h6>
                                        <span v-html="discountCoditions(discount)"></span></td>
                                    <td class="center">{{ printDate(discount.sale_start_at) }}</td>
                                    <td class="center">{{ printDate(discount.sale_end_at) }}</td>
                                    <td class="center">{{ printDate(discount.start_at) }}</td>
                                    <td class="center">{{ printDate(discount.end_at) }}</td>
                                    <td class="center">{{ discount.value_percent }}</td>
                                    <td class="center">{{ formatPriceKop(discount.value_fixed) }}</td>
                                    <td class="center">{{ discount.value_days }}</td>
                                    <td class="center">
                                        <!-- <input type="checkbox" v-model="" @change="onChangeApplyDiscount(discount)"  class="custom-control-input"/> -->

                                        <b-form-group>
                                            <div class="custom-control custom-checkbox custom-control-inline">
                                                <input type="checkbox" class="custom-control-input"
                                                       :id="'applied_discounts'+discount.id" value="1"
                                                       v-model="applied_discounts[discount.id.toString()]"
                                                       @change="onChangeApplyDiscount(discount)">
                                                <label class="custom-control-label"
                                                       :for="'applied_discounts'+discount.id">прим</label>
                                            </div>
                                        </b-form-group>

                                    </td>
                                </tr>
                            </table>

                        </b-card-body>
                    </b-collapse>
                </b-card>
            </b-col>

        </div>

        <b-card>

            <div>
                <button class="btn btn-sm btn-mg btn-secondary" @click="onClose()"><i class="icon-logout"></i> Вернуться
                    в список
                </button>

                <button class="btn btn-sm btn-mg btn-danger" @click="onClickCancel()"
                        v-if="canSmCancel(voucher)||canSmRefuse(voucher)"><i class="fa fa-times"></i> Аннулировать
                </button>
                <button class="btn btn-sm btn-mg btn-success" @click="onRecycleVoucher()" v-if="canSmCancel(voucher)"><i
                    class="fa fa-recycle"></i> Пересоздать
                </button>

                <button class="btn btn-sm btn-mg btn-danger" @click="onClickDrop()" v-if="canSmDrop(voucher)"><i
                    class="fa fa-times"></i> Удалить
                </button>
                <button class="btn btn-sm btn-mg btn-danger" @click="onClickRevoke()" v-if="canDoRevoke(voucher)"><i
                    class="fa fa-times"></i> Аннулировать
                </button>
                <button class="btn btn-sm btn-mg btn-danger" @click="onClickAnnul()" v-if="canDoAnnul(voucher)"><i
                    class="fa fa-times"></i> Аннулировать Бронь
                </button>
                <button class="btn btn-sm btn-mg btn-warning" @click="onClickChangeUser()"
                        v-if="canChangeUser(voucher)"><i class="fa fa-user"></i> Передать путевку
                </button>
                <button class="btn btn-sm btn-mg btn-success" @click="onCalcPrices()" v-if="canCalcPrices(voucher)"><i
                    class="fa fa-calculator"></i> Рассчитать цены
                </button>
                <button class="btn btn-sm btn-mg btn-success" @click="onApply()" v-if="canSave(voucher)"><i
                    class="fa fa-save"></i> Сохранить
                </button>
                <button class="btn btn-sm btn-mg btn-success" @click="onSave()" v-if="canSave(voucher)"><i
                    class="fa fa-save"></i> Сохранить и выйти
                </button>
                <button class="btn btn-sm btn-mg btn-primary" @click="onPreProcess()" v-if="canSmPreprocess(voucher)"><i
                    class="fa fa-arrow-right"></i> Принять в работу
                </button>
                <button class="btn btn-sm btn-mg btn-success" @click="onGetInvoice()" v-if="canGetInvoice(voucher)"><i
                    class="fa fa-arrow-right"></i> Получить номер счета
                </button>
                <button class="btn btn-sm btn-mg btn-primary" @click="onSendToExecute()"
                        v-if="canSendToExecute(voucher)"><i class="fa fa-bicycle"></i> Отправить в исполнение
                </button>
                <button class="btn btn-sm btn-mg btn-primary" @click="onSetbook()" v-if="canSmSetbook(voucher)"><i
                    class="fa fa-arrow-right"></i> Запросить бронь
                </button>
                <button class="btn btn-sm btn-mg btn-primary" @click="onAgencyPay()" v-if="canSmAgencyPay(voucher)"><i
                    class="fa fa-arrow-right"></i> Оплатить
                </button>
                <button class="btn btn-sm btn-mg btn-primary" @click="onSysPay()" v-if="canSmSysPay(voucher)"><i
                    class="fa fa-arrow-right"></i> Оплатить объекту
                </button>

                <button class="btn btn-sm btn-mg btn-success" @click="onClickRequest()" v-if="canSmRequest(voucher)"><i
                    class="fa fa-send"></i> Запрос наличия мест
                </button>
                <button class="btn btn-sm btn-mg btn-success" @click="onClickPresence()" v-if="canDoResponse(voucher)">
                    <i class="fa fa-arrow-right"></i> Подтвердить наличие мест
                </button>
                <button class="btn btn-sm btn-mg btn-danger" @click="onClickAbsence()" v-if="canDoResponse(voucher)"><i
                    class="fa fa-arrow-right"></i> Мест выбранной категории нет
                </button>
                <button class="btn btn-sm btn-mg btn-primary" @click="onClickRevert()" v-if="canDoRevert(voucher)"><i
                    class="icon-action-undo"></i> Вернуть в подготовку
                </button>
                <button class="btn btn-sm btn-mg btn-primary" @click="onClickClone()" v-if="canDoClone(voucher)"><i
                    class="fa fa-clone"></i> Клонировать
                </button>

                <button class="btn btn-sm btn-mg btn-success" @click="onAgree()" v-if="canSmAgree(voucher)"><i
                    class="fa fa-arrow-right"></i> Забронировать
                </button>
                <button class="btn btn-sm btn-mg btn-danger" @click="onClickBookReject()" v-if="canSmDeny(voucher)"><i
                    class="fa fa-arrow-right"></i> Отказать
                </button>
                <button class="btn btn-sm btn-mg btn-success" @click="doAccept()" v-if="canSmAccept(voucher)"><i
                    class="fa fa-arrow-right"></i> Запрос отправлен
                </button>
                <button class="btn btn-sm btn-mg btn-success" @click="onClickBookApply()" v-if="canSmBook(voucher)"><i
                    class="fa fa-arrow-right"></i> Забронировать
                </button>

                <button class="btn btn-sm btn-mg btn-success" @click="onCalcFee()"><i
                    class="fa fa-send"></i> Пересчитать вознаграждение
                </button>

            </div>

            <p>
                <small>
                    Оперция "вернуть в подготовку" доступна админам в любом состоянии, остальным - только в
                    "рабочем"<br>
                    <span class="bg-primary">Синие кнопки</span> выполняют действие<br>
                    <span class="bg-success">Зеленые кнопки</span> сохраняют путевку и выполняют действие<br>
                </small>
            </p>

            <br/><br/>

            <div>

                <button class="btn btn-sm btn-mg btn-secondary" @click="onPrintContract"
                        :disabled="!canSmPrintContract(voucher)"><i class="fa fa-print"></i> Договор
                </button>
                <button class="btn btn-sm btn-mg btn-secondary" @click="onPrintVoucher"
                        :disabled="!canSmPrintVoucher(voucher)"><i class="fa fa-print"></i> Обменная путевка
                </button>
                <button class="btn btn-sm btn-mg btn-secondary" @click="onPrintInvoice"
                        :disabled="!canSmPrintInvoice(voucher)" v-if="is_agent_or_agency||is_admin"><i
                    class="fa fa-print"></i> Счет
                </button>
                <button class="btn btn-sm btn-mg btn-secondary" @click="printCheckinList(voucher)"
                        :disabled="!canSmPrintCheckinList(voucher)"><i class="fa fa-print"></i> Лист заезжающего
                </button>
                <button class="btn btn-sm btn-mg btn-secondary" @click="printVst(voucher)"
                        :disabled="!canSmPrintCheckinList(voucher)"><i class="fa fa-print"></i> Баннер для встречи
                </button>
                <button class="btn btn-sm btn-mg btn-secondary" @click="printCalc(voucher)"
                        :disabled="!canSmPrintInvoice(voucher) || !is(voucher.calculation)"><i class="fa fa-print"></i>
                    Калькуляция
                </button>
                <button class="btn btn-sm btn-mg btn-secondary" @click="printHotelBookRequest(voucher)"
                        :disabled="!canSmPrintHotelRequest(voucher)"><i class="fa fa-print"></i> Заявка
                </button>
                <button class="btn btn-sm btn-mg btn-secondary" @click="printHotelChangeRequest(voucher)"
                        :disabled="!canSmPrintHotelChange(voucher)"><i class="fa fa-print"></i> Корректировка
                </button>
                <button class="btn btn-sm btn-mg btn-secondary" @click="printHotelCancelRequest(voucher)"
                        :disabled="!canSmPrintHotelCancel(voucher)"><i class="fa fa-print"></i> Аннуляция
                </button>
                <button class="btn btn-sm btn-mg btn-secondary" @click="sendDocuments(voucher)"><i
                    class="fa fa-send"></i> Выслать документы клиенту
                </button>

            </div>
        </b-card>

        <b-card no-body>
            <div slot="header">
                <strong>Информация</strong>
                <div class="card-header-actions">
                    <b-link class="card-header-action btn-minimize" v-b-toggle.collapse_info>
                        <i class="icon-arrow-up"></i>
                    </b-link>
                </div>
            </div>
            <b-collapse id="collapse_info" visible v-model="show_info">
                <b-card-body>
                    <b-tabs>
                        <b-tab title="Объект размещения" active v-if="isHotelLoaded()">
                            <h5 @click="onShowHotelDialog(hotel.id)">{{hotel.title}}
                                <b v-for="i in hotel.stardom">*</b>
                                <small><a href="" @click.prevent="onShowHotelDialog(hotel.id)">подробнее</a></small>
                            </h5>

                            <p>
                                <u>Время заезда:</u> {{ hotel.time_check_in }}
                            </p>
                            <p>
                                <u>Время выезда:</u> {{ hotel.time_check_out }}
                            </p>
                            <p>
                                <u>Время расчетов (расчетный час):</u> {{ hotel.time_check_payment }}
                            </p>
                            <p v-if="is(hotel.sys_conditions_booking_client)"
                               v-html="'<u>Условия бронирования с клиентом:</u> '+$options.filters.linebreaksbr(hotel.sys_conditions_booking_client)">
                            </p>
                            <p v-if="is(hotel.sys_conditions_payment_client)"
                               v-html="'<u>Условия и сроки оплаты с клиентом:</u> '+$options.filters.linebreaksbr(hotel.sys_conditions_payment_client)">
                            </p>
                            <p v-if="is(hotel.sys_conditions_cancellation_client)"
                               v-html="'<u>Условия и сроки аннуляции (штрафов) с клиентом:</u> '+$options.filters.linebreaksbr(hotel.sys_conditions_cancellation_client)">
                            </p>
                            <p v-if="is(hotel.sys_contract_prepayment_size)">
                                <u>Размер предоплаты (в %):</u> {{ hotel.sys_contract_prepayment_size }}
                            </p>
                            <p v-if="is(hotel.sys_contract_prepayment_day)">
                                <u>Количество дней отведенные на предоплату:</u> {{ hotel.sys_contract_prepayment_day }}
                            </p>
                            <p v-if="is(hotel.sys_contract_payment_full_day)">
                                <u>Количество дней отведенные на полную оплату:</u> {{
                                hotel.sys_contract_payment_full_day }}
                            </p>

                            <template v-if="is_manager_or_buh || is_agent_plus || is_admin">
                                <p v-if="is(hotel.phones)">
                                    <u>phones:</u> {{ hotel.phones }}
                                </p>
                                <p v-if="is(hotel.email)">
                                    <u>Email:</u> {{ hotel.email }}
                                </p>
                                <p v-if="is(hotel.url)">
                                    <u>Сайт:</u> &nbsp; <a :href="hotel.url" target="_blank">{{ hotel.url }}</a>
                                </p>
                                <p v-if="is(hotel.contacts_other)">
                                    <u>Дополнительные контакты:</u> {{ hotel.contacts_other }}
                                </p>
                                <p v-if="is(hotel.nsb_contract_m_subscribed)">
                                    Договор подписан
                                </p>
                                <p v-if="is(hotel.cooperation)">
                                    <u>Условия сотрудничества:</u> {{ hotel.cooperation }}
                                </p>
                            </template>

                            <p v-if="is(hotel.address)">
                                <u>Адрес объекта размещения:</u> {{ hotel.address }}
                            </p>
                            <p v-if="is(hotel.info_other)"
                               v-html="'<u>Дополнительные условия и информация:</u> '+$options.filters.linebreaksbr(hotel.info_other)">
                            </p>
                        </b-tab>
                        <b-tab title="Цены" v-if="isHotelLoaded()">
                            <b-button variant="primary" @click="onShowPrices()"><i class="fa fa-refresh"></i>
                                {{is_prices_loaded?'Обновить цены':'Показать цены'}}
                            </b-button>
                            <br/><br/>
                            <template v-if="is_prices_loaded">
                                <prices-table
                                    :hotel="hotel"
                                    :prices="prices"
                                    :filterroomid="0"
                                    :filterprogramid="0"
                                    mode="room"
                                ></prices-table>
                            </template>

                            <b-alert show variant="danger" v-if='isNoQuotas()'>
                                {{ no_prices }}
                            </b-alert>
                        </b-tab>
                        <b-tab title="Квоты" v-if="isHotelLoaded()">
                            <b-button variant="primary" @click="onShowQuotas()"><i class="fa fa-refresh"></i>
                                {{isQuotasLoaded()?'Обновить квоты':'Показать квоты'}}
                            </b-button>
                            &nbsp;
                            <b-button variant="primary" @click="onClickRequest()"><i class="fa fa-send"></i> Запрос
                                наличия мест
                            </b-button>
                            <br/><br/>
                            <div class="flex-form" v-if="isQuotasLoaded()">
                                <p v-if="quotas.otherrooms && quotas.otherrooms.length">Кроме приведенных в таблице
                                    имеются другие квоты, которые не могут быть
                                    показаны так как нет привязки к номерам НСБ. Обратитесь к операторам, ответственным
                                    за связку данных
                                    объекта и данных НСБ ({{quotas.otherrooms}}).</p>
                            </div>
                            <table style="width:100%;" v-if="isQuotasLoaded()"
                                   class="table b-table table-striped table-hover table-bordered table-sm b-table-fixed">
                                <tr>
                                    <td v-for="(s,i) in quotas.dates" :key="i">{{s.slice(8, 10)}}.{{s.slice(5, 7)}}</td>
                                </tr>
                                <template v-for="room in quotas.rooms">
                                    <tr>
                                        <td :colspan="Object.keys(quotas.dates).length">
                                            {{ getRoomTitleById(room.id) }} (<span v-if="room.pk">профкурорт</span><span
                                            v-if="!room.pk">НСБ</span>)
                                        </td>
                                    </tr>
                                    <tr>
                                        <td v-for="(s,i) in room.data" :key="i"
                                            :class="is(s)&&(s!=='0')?'text-center alert-primary':'text-center alert-danger'">
                                            {{is(s)&&(s!=='0')?s:''}}
                                        </td>
                                    </tr>
                                </template>
                            </table>
                            <b-alert show variant="danger" v-if='isNoQuotas()'>
                                {{ no_quotas }}
                            </b-alert>
                        </b-tab>
                        <b-tab title="Калькуляция" :disabled="calculation===null">
                            <table style="width:100%;"
                                   class="table b-table table-striped table-hover table-bordered table-sm b-table-fixed"
                                   v-if="calculation!==null">
                                <tr>
                                    <th rowspan="4">Даты</th>
                                    <th colspan="4" v-for="(name,i) in calculation.names">
                                        {{ name }}
                                    </th>
                                </tr>
                                <tr>
                                    <th colspan="4" v-for="(age,i) in calculation.ages">
                                        {{ age }}
                                    </th>
                                </tr>
                                <tr>
                                    <th colspan="4" v-for="(program,i) in calculation.programs">
                                        {{ program }}
                                    </th>
                                </tr>
                                <tr>
                                    <template colspan="4" v-for="(program,i) in calculation.programs">
                                        <th>Стоимость</th>
                                        <th colspan="2">Скидка</th>
                                        <th>Со скидкой</th>
                                    </template>
                                </tr>
                                <tr v-for="(daycalc, dat) in calculation.prices">
                                    <td>{{ dat=='total'?'Итого':dat }}</td>
                                    <template v-for="(price,i) in daycalc" v-if="calculation.newprices">
                                        <td class="text-right">{{ formatPriceKop(price.value) }}</td>
                                        <td>{{ price.discount_title }}</td>
                                        <td class="text-right">{{ formatPriceKop(price.discount) }}</td>
                                        <td class="text-right">{{ formatPriceKop(price.value - price.discount) }}</td>
                                    </template>
                                    <template v-for="(price,i) in daycalc" v-else>
                                        <td class="text-right">{{ formatPrice(price.value) }}</td>
                                        <td>{{ price.discount_title }}</td>
                                        <td class="text-right">{{ formatPrice(price.discount) }}</td>
                                        <td class="text-right">{{ formatPrice(price.value - price.discount) }}</td>
                                    </template>
                                </tr>
                            </table>
                        </b-tab>
                    </b-tabs>
                </b-card-body>
            </b-collapse>
        </b-card>


        <b-modal :title="errorTitle" class="modal-danger" centered v-model="errorModal" ok-variant="danger">
            {{errorText}}
            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }">
                <b-button size="sm" variant="outline-primary" @click="cancel()">OK</b-button>
            </template>
        </b-modal>

        <b-modal title="Анулирование путевки" class="modal-danger" centered v-model="showCancelModal"
                 ok-variant="danger" @ok="handleCancelOk">
            <form ref="cancelForm" @submit.stop.prevent="handleCancelOk">
                <p v-if="cancel_recycle">
                    Данная путевка будет аннулирована, вместо нее будет создана новая путевка.
                </p>

                <b-form-group v-if="this.smIsActiveBookings(voucher) && this.canSmRefuse(voucher) || is_admin">
                    <div class="custom-control custom-checkbox custom-control-inline">
                        <input type="checkbox" class="custom-control-input" id="revoke_booking_only" value="1"
                               v-model="revoke_booking_only">
                        <label class="custom-control-label" for="revoke_booking_only">Требуется аннулировать только
                            бронь, сама путевка остается в работе.</label>
                    </div>
                </b-form-group>

                <b-form-group
                    :state="reasonState"
                    label="Укажите причину аннулирования для продолжения"
                    label-for="name-input"
                    invalid-feedback="Причина аннулирования должна быть указана"
                >
                    <b-form-textarea
                        id="name-input"
                        v-model="reason"
                        :state="reasonState"
                        required
                    ></b-form-textarea>
                </b-form-group>
            </form>
            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }"></template>
        </b-modal>

        <b-modal title="Анулирование путевки" class="modal-danger" centered v-model="showRevokeModal"
                 ok-variant="danger" @ok="handleRevokeOk">
            <form ref="revokeForm" @submit.stop.prevent="handleRevokeOk">

                <b-form-group label="Штраф за аннуляцию">
                    <input class="form-control" v-model.number="_penalty"/>
                </b-form-group>

                <b-form-group
                    :state="reasonState"
                    label="Укажите комментарий"
                    label-for="name-input"
                    invalid-feedback="Причина аннулирования должна быть указана"
                >
                    <b-form-textarea
                        id="name-input"
                        v-model="reason"
                        :state="reasonState"
                        required
                    ></b-form-textarea>
                </b-form-group>
            </form>
            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }"></template>
        </b-modal>

        <b-modal title="Анулирование брони" class="modal-danger" centered v-model="showAnnulModal" ok-variant="danger"
                 @ok="handleAnnulOk">
            <form ref="annulForm" @submit.stop.prevent="handleAnnulOk">

                <b-form-group label="Штраф за аннуляцию">
                    <input class="form-control" v-model.number="_penalty"/>
                </b-form-group>

                <b-form-group
                    :state="reasonState"
                    label="Укажите комментарий"
                    label-for="name-input"
                    invalid-feedback="Причина аннулирования брони должна быть указана"
                >
                    <b-form-textarea
                        id="name-input"
                        v-model="reason"
                        :state="reasonState"
                        required
                    ></b-form-textarea>
                </b-form-group>
            </form>
            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }"></template>
        </b-modal>

        <b-modal title="Запрос наличия мест" class="modal-primary" centered v-model="showRequestConfirm"
                 ok-variant="primary" @ok="handleRequestOk">
            <form ref="requestConfirmForm" @submit.stop.prevent="handleRequestOk">
                <p>
                    Будет создан запрос о наличии мест для ручной обработки менеджерами НСБ.
                </p>

                <b-form-group>
                    <div class="custom-control custom-checkbox custom-control-inline">
                        <input type="checkbox" class="custom-control-input" id="other-room" value="1"
                               v-model="requestOtherRoom">
                        <label class="custom-control-label" for="other-room">Рассматриваем варианты заселения в другом
                            номере</label>
                    </div>
                </b-form-group>

                <b-form-group>
                    <div class="custom-control custom-checkbox custom-control-inline">
                        <input type="checkbox" class="custom-control-input" id="other-object" value="1"
                               v-model="requestOtherObject">
                        <label class="custom-control-label" for="other-object">Рассматриваем варианты заселения в другом
                            объекте</label>
                    </div>
                </b-form-group>


                <b-form-group>
                    <div class="custom-control custom-checkbox custom-control-inline">
                        <input type="checkbox" class="custom-control-input" id="other-dates" value="1"
                               v-model="requestOtherDates">
                        <label class="custom-control-label" for="other-dates">Рассматриваем смещение изменение
                            дат</label>
                    </div>
                </b-form-group>


                <b-form-group
                    label="Дополнительный комментарий  свободной форме."
                >
                    <b-form-textarea v-model="addComment"
                                     placeholder="Пожалуйста укажите рассматриваете ли клиент альтернативы по размещению в других категориях номеров или в других объектах."
                                     rows="4"
                                     no-resize
                    ></b-form-textarea>
                </b-form-group>
            </form>
            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }"></template>
        </b-modal>

        <b-modal title="Места есть" class="modal-success" centered v-model="showPresenceConfirm" ok-variant="success"
                 @ok="handlePresenceOk">
            <form ref="presenceConfirmForm" @submit.stop.prevent="handlePresenceOk">
                <b-form-group label="Дополнительный комментарий  свободной форме.">
                    <b-form-textarea v-model="addComment"></b-form-textarea>
                </b-form-group>
            </form>
            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }">

            </template>
        </b-modal>

        <b-modal title="Мест нет" class="modal-danger" centered v-model="showAbsenceConfirm" ok-variant="danger"
                 @ok="handleAbsenceOk">
            <form ref="absenceConfirmForm" @submit.stop.prevent="handlePresenceSubmit">
                <b-form-group label="Дополнительный комментарий  свободной форме.">
                    <b-form-textarea v-model="addComment"></b-form-textarea>
                </b-form-group>
            </form>
            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }">

            </template>
        </b-modal>

        <b-modal title="Отказ в бронировании путевки" class="modal-danger" centered v-model="showBookRejectModal"
                 ok-variant="danger" @ok="handleBookReject">
            <form ref="bookRejectForm" @submit.stop.prevent="handleBookReject">
                <b-form-group
                    :state="bookRejectCommentState"
                    label="Укажите причину отказа бронирования"
                    label-for="name-input"
                    invalid-feedback="Причина отказа бронирования должна быть указана"
                >
                    <b-form-textarea
                        id="name-input"
                        v-model="addComment"
                        :state="bookRejectCommentState"
                        required
                    ></b-form-textarea>
                </b-form-group>
            </form>
            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }">

            </template>
        </b-modal>


        <hotel-info-dialog :hotelid='hotelInfoId' v-model="showHotelDialog" @hide="onHideHotelDialog"/>
        <booking-create-dialog-profkurort :voucherx='voucher' :bookingsx='voucher.bookings'
                                          v-model="showBookingCreateDialogProfkurort"/>
        <booking-create-dialog :voucherx='voucher' :hotelx='hotel' v-model="showBookingCreateDialog"
                               @booked="onBooked" v-if="isVoucherLoaded()&& isHotelLoaded()&&showBookingCreateDialog"/>

        <guest-edit-dialog :programs="programs" :guest='guestOnEdit' v-model="showGuestEditDialog"
                           @update="calculateVoucherTotals()"/>
        <change-user-dialog :voucherx='voucher' v-model="showChangeUserDialog" @changeuser="onDoChangeUser"/>
        <invoices-split-dialog :voucherx='voucher' :guestsx="guests" :programsx="programs"
                               v-model="showInvoicesSplitDialog"
                               :mode="printMode" @print="saveGuests(doPrint)"></invoices-split-dialog>
        <print-faximile-dialog :voucherx='voucher' v-model="showPrintFaximileDialog"
                               @print="doPrint"></print-faximile-dialog>
        <create-reminder-dialog :voucher_id="voucher.id" v-model="showCreateTaskDialog"></create-reminder-dialog>
        <status-dialog :voucherx='voucher' v-model="showStatusDialog"
                       @changed="doUpdateStatusCloseTime"></status-dialog>
        <edit-customer-dialog v-model="showEditCustomerDialog" @changed="customerChanged"
                              v-if="showEditCustomerDialog"></edit-customer-dialog>
        <show-customer-dialog v-model="showShowCustomerDialog" v-if="showShowCustomerDialog"></show-customer-dialog>
        <create-customer-dialog :voucherx='voucher' v-model="showCreateCustomerDialog" @changed="customerSelected"
                                v-if="showCreateCustomerDialog"></create-customer-dialog>
        <booking-show-dialog v-model="showBookingId" v-if="showBookingId"></booking-show-dialog>
        <ticket-edit-dialog :voucherx='voucher' v-model="showShowTicketEditDialog"
                            v-if="showShowTicketEditDialog" @ok="onSavedTicket()"></ticket-edit-dialog>

        <b-modal title="Путевка оплачена Агентством" class="modal-success" centered v-model="showBookingBillPayedModal"
                 ok-variant="success" @ok="handleBookingBillPayed">
            <form ref="bookingBillPayedForm" @submit.stop.prevent="handleBookingBillPayed">
                Это окно видит бухалтер (или менеджер тоже?). Он вводит тут реквизиты платежного, полученного из банка
                (или письмо от агентства). После проведения оплаты Агентства статуст брони становится "Оплачено",
                статус путевки - "Оплачено" - это новый статус, раньше такого не было. А Пока ввод документов делается в
                простом текстовом виде. В дальнейшем эта операция будет проводиться автоматически.
            </form>
            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }">

            </template>
        </b-modal>
        <b-modal title="Путевка оплачена Системой" class="modal-success" centered v-model="showBookingInvoicePayedModal"
                 ok-variant="success" @ok="handleBookingInvoicePayed">
            <form ref="bookingInvoicePayedForm" @submit.stop.prevent="handleBookingInvoicePayed">
                Это окно видит бухалтер (или менеджер тоже?). Он вводит тут реквизиты платежного, полученного из банка
                (или письмо от агентства). После проведения оплаты Агентства статуст брони становится "Выкуплено",
                статус путевки - "Выкуплено" (это замена старого статуса "Исполняется"). А Пока ввод документов делается
                в
                простом текстовом виде. В дальнейшем эта операция будет проводиться автоматически.
            </form>
            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }">
            </template>
        </b-modal>
        <b-modal title="Дата заезда меньше текущей" class="modal-success" centered v-model="showAgreeModal"
                 ok-variant="success" @ok="handleAgreeOk">
            <b-alert show variant="danger">
                <p>
                    Вы уверены что все делаете правильно ?
                </p>

                <form ref="absenceConfirmForm" @submit.stop.prevent="handleAgreeOk">
                    <b-form-group label="Дополнительный комментарий  свободной форме.">
                        <b-form-textarea v-model="addComment"></b-form-textarea>
                    </b-form-group>
                </form>

            </b-alert>

            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }">

            </template>
        </b-modal>
        <b-modal title="Дата заезда меньше текущей" class="modal-danger" centered v-model="showRequestDenyModal">
            <b-alert show variant="danger">
                <p>
                    Дата заезда не должна быть меньше текущей
                </p>

            </b-alert>

            <template slot="modal-footer" slot-scope="{ cancel, hide }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Отмена
                </b-button>
            </template>
        </b-modal>
        <b-modal title="Оплата путевки брони" class="modal-success" centered v-model="showPayAgencyModal"
                 ok-variant="success" @ok="doSmPayAgency">

            <template v-if="balance">
                <p>
                    Для оплаты путевки будут списаны средства с актива и заблокированы. Если средств не достаточно -
                    попробуем занять в долг.
                </p>

                Будет списано: {{ formatPriceKop(bookingsSumBill()) }}<br>
                Доступно для блокировки: {{ formatPriceKop(booking_limit) }}<br>
                Доступно для блокировки с учетом кредита: {{ formatPriceKop(credit_limit) }}<br>
                <b-alert show variant="danger" v-if="!can_agency_pay_book">
                    На вашем счету недостаточно средств для оплаты брони.
                </b-alert>
            </template>
            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }">

                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Отказаться от оплаты
                </b-button>

                <b-button size="sm" variant="outline-success" @click="ok()" :disabled="!can_agency_pay_book">
                    Оплатить
                </b-button>

            </template>
        </b-modal>
        <b-modal title="Оплата путевки брони" class="modal-success" centered v-model="showPaySystemModal"
                 ok-variant="success" @ok="doSmPaySystem">

            <template v-if="balance">
                <p>
                    Для оплаты путевки будут списаны средства с актива и заблокированы. Если средств не достаточно -
                    попробуем занять в долг.
                </p>

                Будет списано: {{ formatPriceKop(bookingsSumInvoice()) }}<br>
                Доступно для блокировки: {{ formatPriceKop(object_booking_limit) }}<br>
                <b-alert show variant="danger" v-if="!can_system_pay_book">
                    На счету в объекте недостаточно средств для оплаты брони.
                </b-alert>
            </template>
            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }">

                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Отказаться от оплаты
                </b-button>

                <b-button size="sm" variant="outline-success" @click="ok()" :disabled="!can_system_pay_book">
                    Оплатить
                </b-button>

            </template>
        </b-modal>
        <b-modal title="Отмена брони" class="modal-danger" centered v-model="showCancelBookingModal" ok-variant="danger"
                 @ok="handleCancelBooking">
            <b-alert show variant="danger">
                <p>
                    Данная операция предназначена для отмены ошибочной брони. Ее следует выполнять,
                    если по какой-то причине у путевки появилась лишняя активная бронь. Менеджер должен проверить
                    что этой брони реальности нет или она отменена или что это дубликат существующей брони.
                    <br>
                    Отмена брони никак не меняет статуса путевки!
                </p>
            </b-alert>

            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }">

            </template>
        </b-modal>
        <b-modal title="Добавление брони" class="modal-success" centered v-model="showCreateBookingModal"
         ok-variant="success" @ok="handleCreateBooking">
    <b-alert show variant="danger">
        <p>
            Данная операция предназначена для добавления брони. Ее следует выполнять,
            если по какой-то причине у путевки не установлена бронь. Менеджер должен проверить
            что добавляемая бронь существует - также как и в обычном бронировании.
            <br>
            Добавление брони никак не меняет статуса путевки!
        </p>
    </b-alert>

    <template slot="modal-footer" slot-scope="{ ok, cancel, hide }">

    </template>
</b-modal>
        <b-modal title="Отмена Билета" class="modal-danger" centered v-model="showCancelTicketModal" ok-variant="danger"
                 @ok="handleCancelTicket">
            <b-alert show variant="danger">
                <p>
                    Данная операция предназначена для отмены билета. Билет останется в списе,
                    но не будет учитываться при расчете сумм.
                </p>
            </b-alert>

            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }">

            </template>
        </b-modal>

    </div>
</template>

<script>
    import {functions} from '@/functions';
    import {sm_functions} from '@/sm_functions';
    import {sm_conditions} from '@/sm_conditions';
    import {functions_loaders} from '@/functions_loaders';
    import {functions_voucher} from '@/functions_voucher';
    import {functions_discount} from '@/functions_discount';
    import {functions_booking} from '@/functions/booking';
    import {functions_hotel} from '@/functions/hotel.js';
    import {functions_city} from '@/functions_city.js';
    import {functions_price} from '@/functions_price';
    import {functions_customers} from '@/functions_customers';
    import {functions_order} from '@/functions_order';
    import {functions_voucher_actions} from '@/functions_voucher_actions';
    import {functions_voucher_print} from '@/functions_voucher_print.js';

    import {functions_room} from '@/functions_room.js';
    import {functions_program} from '@/functions/program.js';
    import {functions_tickets} from '@/functions/tickets.js';
    import {functions_guests} from '@/functions/guests.js';

    import {Switch as cSwitch} from '@coreui/vue'
    import {CONSTANTS} from '@/constants'
    import PricesTable from '@/components/PricesTable';
    import HotelInfoDialog from '@/dialogs/HotelInfoDialog'
    import BookingCreateDialogProfkurort from '@/dialogs/BookingCreateDialogProfkurort'
    import GuestEditDialog from '@/dialogs/GuestEditDialog'
    import ChangeUserDialog from '@/dialogs/ChangeUserDialog'
    import InvoicesSplitDialog from '@/dialogs/InvoicesSplitDialog'
    import PrintFaximileDialog from '@/dialogs/PrintFaximileDialog'
    import CreateReminderDialog from '@/dialogs/CreateReminderDialog'
    import BookingCreateDialog from '@/dialogs/BookingCreateDialog'
    import StatusDialog from '@/dialogs/StatusDialog'
    import CreateCustomerDialog from '@/dialogs/CreateCustomerDialog'
    import EditCustomerDialog from '@/dialogs/EditCustomerDialog'
    import ShowCustomerDialog from '@/dialogs/ShowCustomerDialog'
    import BookingShowDialog from '@/dialogs/BookingShowDialog'
    import TicketEditDialog from '@/dialogs/TicketEditDialog'
    import moment from 'moment'

    import CityInput from '@/components/CityInput'
    import Hotel from "../tech/Hotel";

    const AGE_TARIF_BASE = 0;
    //const AGE_TARIF_CHILD = 1;
    const AGE_TARIF_INFANT = 2;
    const AGE_TARIF_NOTPERMIT = 3;
    //const AGE_TARIF_FREEPLACE = 4;

    const today = new Date()
    //    setupCalendar({
    //        firstDayOfWeek: 2, // Monday
    //        datePickerShowDayPopover: false,
    //        showLinkedButtons:true,
    //    })

    const initial_skip_default = {
        onChangeDates: 2
    };

    export default {
        name: 'NsbAgentVoucher',
        mixins: [functions, functions_loaders, functions_voucher, functions_discount, sm_functions, sm_conditions,
            functions_voucher_actions, functions_voucher_print, functions_customers, functions_room, functions_program,
            functions_price, functions_order, functions_hotel, functions_booking, functions_city, functions_tickets,
            functions_guests],

        components: {
            cSwitch,
            PricesTable,
            HotelInfoDialog,
            BookingCreateDialogProfkurort,
            BookingCreateDialog,
            GuestEditDialog,
            ChangeUserDialog,
            CityInput,
            InvoicesSplitDialog,
            PrintFaximileDialog,
            CreateReminderDialog,
            StatusDialog,
            CreateCustomerDialog,
            EditCustomerDialog,
            ShowCustomerDialog,
            BookingShowDialog,
            TicketEditDialog
        },
        data() {
            return {
                //SHIT
                selected: [], // Must be an array reference!
                show: true,
                loaded: false,
                //SHIT

                voucher_id: null,
                calculation: null,
                availability: null,

                labelIcon: {dataOn: '\u2713', dataOff: '\u2715'},
                labelTxt: {dataOn: 'да', dataOff: 'нет'},
                labelTxtFlUl: {dataOn: 'юридическое лицо', dataOff: 'физическое лицо'},
                ages: this.range(0, 100),
                errorText: '',
                errorTitle: '',
                errorModal: false,

                hotelInfoId: null,
                guestOnEdit: null,
                applied_discounts: {},
                printMode: null,
                addComment: null,
                requestOtherRoom: null,
                requestOtherObject: null,
                requestOtherDates: null,

                reason: null,
                reasonState: null,
                bookRejectCommentState: null,

                showCancelModal: false,  /* диалог запроса отмены путевки */
                showRevokeModal: false,  /* диалог отмены путевки */
                showAnnulModal: false,  /* диалог отмены брони */
                showPresenceConfirm: false, /* диалог положительного ответа на запрос мест */
                showAbsenceConfirm: false,  /* диалог отрицательного ответа на запрос мест */
                showRequestConfirm: false,  /* диалог запроса мест */

                showHotelDialog: false,
                showBookingCreateDialog: false,
                showGuestEditDialog: false,
                showChangeUserDialog: false,
                showInvoicesSplitDialog: false,
                showPrintFaximileDialog: false,
                showCreateTaskDialog: false,
                showBookRejectModal: false,
                showBookingCreateDialogProfkurort: false,
                showBookingBillPayedModal: false,
                showBookingInvoicePayedModal: false,
                showRequestDenyModal: false,  /* диалог отказа запроса мест */
                showAgreeModal: false,
                showPayAgencyModal: false,
                showPaySystemModal: false,
                showStatusDialog: false,
                showCreateCustomerDialog: false,
                showEditCustomerDialog: 0,
                showShowCustomerDialog: 0,
                showCancelBookingModal: false,
                bookingToCancel: 0,
                showCreateBookingModal: false,
                showBookingId: 0,
                showShowTicketEditDialog: 0,
                penalty: 0,
                ticketToCancel: 0,
                showCancelTicketModal: false,

                /* мега сука блядь костыль */
                initial_skip: {
                    onChangeDates: 2
                },
            }
        },
        methods: {
            hotelAfterLoad: function (self) {
                console.log('=====> loadHotel');
                self.rooms = self.hotel.rooms;
                self.discounts = self.hotel.discounts;
                console.log('self.discounts', self.discounts);
                self.programs = self.hotel.programs;

                // self.voucher.t_obj_rooms_id = self['t_obj_rooms_id'];
                if (!self.voucher.t_obj_rooms_id) {
                    self.loaded = true;
                    return;
                }
                self.resetRoom().loadRoom(self.voucher.t_obj_rooms_id, function (self) {
                    console.log('=====> loadRoom');
                    self.loaded = true;
                }, self);

                let new_applied_discounts = {};

                for (let [key, value] of Object.entries(this.applied_discounts)) {
                    console.log(`${key}: ${value}`);
                    if (self.discounts.find(function (el) {
                        return el.id == key;
                    })) {
                        console.log('OK');
                        new_applied_discounts[key] = value;
                    }
                }

                console.log('new_applied_discounts', new_applied_discounts);
                this.applied_discounts = new_applied_discounts;
                if (!self.hotel.direct_payment) {
                    this.voucher.m_payment_obj = 0;
                }
            },

            voucherAfterLoad: function () {
                //console.log('voucherAfterLoad')
                //console.log('this', this)
                //console.log('this.voucher', this.voucher)

                if (this.voucher.applied_discounts) {
                    this.applied_discounts = JSON.parse(this.voucher.applied_discounts);
                } else {
                    this.applied_discounts = {};
                }
                this.voucher.m_only_number = !!this.voucher.m_only_number;

                if (this.voucher.calculation && (this.voucher.calculation !== null)) {
                    this.calculation = JSON.parse(this.voucher.calculation);
                    //console.log(this.calculation);
                } else {
                    this.calculation = null;
                }

                this.voucher.is_org = !!this.voucher.is_org

                //this.resetTelenums().loadTelenumsForVoucher(this.voucher_id);
                this.resetTelecalls().loadTelecallsForVoucher(this.voucher_id);

                if (this.is_agent_or_agency || this.us_admin) {
                    this.resetOrder().loadOrder(this.voucher.order_id);
                }
                let self = this;
                //self['t_obj_items_id'] = self.voucher.t_obj_items_id;
                //self['t_obj_rooms_id'] = self.voucher.t_obj_rooms_id;

                this.loadCities(function (self) {
                    console.log('=====> loadCities');
                    if (!self.voucher.t_city_id) {
                        self.voucher.t_obj_items_id = null;
                        self.voucher.t_obj_rooms_id = null;
                        self.loaded = true;
                        return;
                    }
                    self.resetHotels().loadCityHotels(self.voucher.t_city_id, function (self) {
                        console.log('=====> loadCityHotels');
                        //self.voucher.t_obj_items_id = self['t_obj_items_id'];
                        if (!self.voucher.t_obj_items_id) {
                            self.voucher.t_obj_rooms_id = null;
                            self.loaded = true;
                            return;
                        }
                        self.resetHotel().loadHotel(self.voucher.t_obj_items_id, self.hotelAfterLoad, self);
                    }, self);
                }, self);


                for (let i = 0; i < this.voucher.guests.length; i++) {
                    if ((this.voucher.guests[i].date_birthday_iso !== null) && this.voucher.guests[i].date_birthday_iso)
                        this.voucher.guests[i].date_birthday_iso = new Date(this.voucher.guests[i].date_birthday_iso.slice(0, 10));
                    else
                        this.voucher.guests[i].date_birthday_iso = null;
                    this.voucher.guests[i].m_women = !!this.voucher.guests[i].m_women;
                    this.voucher.guests[i].apply_social_discount = !!this.voucher.guests[i].apply_social_discount;
                    this.voucher.guests[i].m_places_additionally = !!this.voucher.guests[i].m_places_additionally;

                    //console.log('this.voucher.guests[i].summa=', this.voucher.guests[i].summa)
                }

                this.guests = this.voucher.guests;
                if (!this.guests.length) {
                    //console.log('addGuest')
                    this.addGuest();
                }

                this.calculateVoucherTotals();

                for (let i = 0; i < this.voucher.guests.length; i++) {
                    //console.log('this.voucher.guests[i].summa=', this.voucher.guests[i].summa)
                }

                this.tickets = this.voucher.tickets;

                //console.log('voucherAfterLoad DONEEEEEEEEEEEEE')
            },

            getSaveData: function () {
                this.voucher.applied_discounts = JSON.stringify(this.applied_discounts);
                let data = {voucher: this.voucher, guests: this.guests, telenums: this.voucher.telenums};
                console.log(data);
                return data;
            },

            onChangeCity: function () {
                if (!this.loaded) return;
                this.voucher.t_obj_items_id = 0;
                this.voucher.t_obj_rooms_id = 0;
                this.voucher.t_obj_tariff_id = 0;
                this.resetHotel();
                this.resetRoom();
                this.resetPrices();
                this.resetPrograms();
                this.resetDiscounts();
                this.resetHotels().loadCityHotels(this.voucher.t_city_id);
                this.resetPersons(true);
                this.availability = null;
            },
            onChangeHotel: function () {
                if (!this.loaded) return;
                this.voucher.t_obj_rooms_id = 0;
                this.voucher.t_obj_tariff_id = 0;
                this.resetPersons(true);
                this.resetHotel().loadHotel(this.voucher.t_obj_items_id, this.hotelAfterLoad, this);
                this.resetPrices();
                this.resetQuotas();
                this.availability = null;
            },
            onChangeRoom: function () {
                if (!this.loaded) return;
                console.log('onChangeHotel')
                this.resetPrices();
                this.resetPersons(false);
                this.resetRoom().loadRoom(this.voucher.t_obj_rooms_id);
                this.availability = null;
            },
            onHotelLoaded: function (self) {
                self.rooms = self.hotel.rooms;
                self.programs = self.hotel.programs;
                self.discounts = self.hotel.discounts;
            },

//            onChangeSumm: function (i) {
//                if (this.isGuestsLoaded())
//                {
//                    this.initGuestValues(i);
//                    if (this.guests[i].discount_percent) {
//                        this.guests[i].discount_value = Math.round(this.guests[i].summa / 100.0 * this.guests[i].discount_percent);
//                    }
//                    this.guests[i].with_discount_value = this.guests[i].summa - this.guests[i].discount_value;
//                    if (this.guests[i].prepay_percent) {
//                        this.guests[i].prepay_value = Math.round(this.guests[i].with_discount_value / 100.0 * this.guests[i].prepay_percent)
//                    }
//                }
//                this.calculateVoucherTotals();
//            },
            onChangeDP: function (i) {
                if (!this.loaded) return;
                this.guests[i].discount_value = Math.round(this.guests[i].summa / 100.0 * this.guests[i].discount_percent);
                this.guests[i].with_discount_value = Math.round(this.guests[i].summa - this.guests[i].discount_value);
                if (this.guests[i].prepay_percent) {
                    this.guests[i].prepay_value = Math.round(this.guests[i].with_discount_value / 100.0 * this.guests[i].prepay_percent)
                }
                this.calculateVoucherTotals();
            },
            onChangeDV: function (i) {
                if (!this.loaded) return;
                this.guests[i].discount_percent = 0;
                this.guests[i].with_discount_value = this.guests[i].summa - this.guests[i].discount_value;

                if (this.guests[i].prepay_percent) {
                    this.guests[i].prepay_value = Math.round(this.guests[i].with_discount_value / 100.0 * this.guests[i].prepay_percent)
                }
                this.calculateVoucherTotals();
            },
            onChangePP: function (i) {
                if (!this.loaded) return;
                if (this.guests[i].prepay_percent) {
                    this.guests[i].prepay_value = Math.round(this.guests[i].with_discount_value / 100.0 * this.guests[i].prepay_percent)
                }
                this.calculateVoucherTotals();
            },
            onChangePV: function (i) {
                if (!this.loaded) return;
                this.guests[i].prepay_percent = 0;
                this.calculateVoucherTotals();
            },
            onChangeDate: function (i) {
                if (!this.loaded) return;
                //alert(this.guests[i].date_birthday_iso);
                let age = Math.floor(Math.abs(new Date() - this.guests[i].date_birthday_iso) / 31557600000);
                this.guests[i].age = age;
            },
            onChangeAge: function (i) {
                if (!this.loaded) return;
                this.guests[i].date_birthday_iso = null;
                //alert(this.guests[i].age);
            },
            onChangeProgram: function (i) {
                if (!this.loaded) return;
                if (this.voucher.m_only_number && (i === 0)) {
                    this.resetPerson(0);
                    for (let i = 1; i < this.guests.length; i++) {
                        this.guests[i].t_obj_tariff_id = this.guests[0].t_obj_tariff_id;
                        this.resetPerson(i);
                    }
                } else if (this.voucher.m_only_number && (i !== 0)) {
                    alert("Shit happens!");
                } else if (!this.voucher.m_only_number) {
                    this.resetPerson(i);
                }
                this.calculateVoucherTotals();
            },

            onAddBed: function () {
                this.addGuest();
            },
            onEditGuest: function (i) {
                this.guestOnEdit = this.guests[i];
                this.showGuestEditDialog = true;
            },
            onDeleteBed: function (i) {
                this.guests.splice(i, 1);
                this.voucher.count_places = this.guests.length;
            },
            onShowQuotas: function () {
                if (!this.isHotelLoaded()) return false;
                this.resetQuotas().loadQuotas(this.voucher.t_obj_items_id, new Date(this._date_begin_iso), new Date(this._date_end_iso));
            },
            onShowPrices: function () {
                console.log('onShowPrices 1')
                if (!this.is_room_loaded) return false;
                console.log('onShowPrices 2')
                this.resetPrices().loadPrices(this.voucher.t_obj_rooms_id);
            },
            onResetPrices: function () {
                for (let i = 0; i < this.guests.length; i++) {
                    this.guests[i].t_obj_tariff_id = this.guests[0].t_obj_tariff_id;
                    this.resetPerson(i);
                }
                this.calculateVoucherTotals();
            },

            onClickDrop: function () {
                this.cancel_recycle = false;
                this.cancel_drop = true;
                this.showCancelModal = true;
            },

            onClickCancel: function () {
                this.cancel_recycle = false;
                this.cancel_drop = false;
                this.showCancelModal = true;
            },

            onRecycleVoucher: function () {
                this.cancel_recycle = true;
                this.cancel_drop = false;
                this.showCancelModal = true;
            },

            onClickRevoke: function () {
                this.showRevokeModal = true;
            },

            onClickAnnul: function () {
                this.showAnnulModal = true;
            },

            checkCancelFormValidity() {
                const valid = this.$refs.cancelForm.checkValidity();
                this.reasonState = valid ? 'valid' : 'invalid';
                return valid;
            },
            handleCancelOk: function (evt) {
                evt.preventDefault();
                if (!this.checkCancelFormValidity()) {
                    return;
                }
                this.doCancel();
            },

            checkRevokeFormValidity() {
                const valid = this.$refs.revokeForm.checkValidity();
                this.reasonState = valid ? 'valid' : 'invalid';
                return valid
            },
            handleRevokeOk: function (evt) {
                evt.preventDefault();
                if (!this.checkRevokeFormValidity()) {
                    return;
                }
                this.doRevoke();
            },

            checkAnnulFormValidity() {
                const valid = this.$refs.annulForm.checkValidity()
                this.reasonState = valid ? 'valid' : 'invalid'
                return valid
            },
            handleAnnulOk: function (evt) {
                evt.preventDefault();
                if (!this.checkAnnulFormValidity()) {
                    return;
                }
                this.doAnnul();
            },

            handleRequestOk: function (evt) {
                this.doVoucherRequest();
            },

            handlePresenceOk: function (evt) {
                this.doVoucherPresence();
            },

            handleAbsenceOk: function (evt) {
                this.doVoucherAbsence();
            },

            checkBookRejectFormValidity() {
                const valid = this.$refs.bookRejectForm.checkValidity()
                this.bookRejectCommentState = valid ? 'valid' : 'invalid'
                return valid
            },
            handleBookReject: function (evt) {
                evt.preventDefault();
                if (!this.checkBookRejectFormValidity()) {
                    return;
                }
                this.doVoucherBookReject();
            },

            handleBookingBillPayed: function () {

            },

            handleBookingInvoicePayed: function () {

            },

            onCalcPrices: function () {
                if (!this.validatePersonsProgram()) {
                    return false;
                }
                this.httpPrepare();
                this.$http.post(this.apiurl('voucher/' + this.voucher_id + '/calc'), this.getSaveData()).then(function (response) {
                    response = this.httpSuccess(response);
                    if (response.result === 'success') {
                        //this.voucher.assign(response.payload.voucher).then(function(){this.voucherAfterLoad();});
                        //this.guests = response.payload.guests;
                        this.reloadVoucher();
                    } else {
                        console.log(response)
                        this.errorModal = true;
                        this.errorTitle = 'Цены не надены';
                        this.errorText = response.error[0];//this.toArray(response.error).join();
                    }
                }, this.httpError);

                return true;
            },
            onSave: function () {
                this.httpPrepare();
                this.$http.post(this.apiurl('voucher/' + this.voucher_id + '/save'), this.getSaveData()).then(function (response) {
                    this.httpSuccess(response);
                    this.setLatestVoucher(this.voucher_id);
                    this.$router.push({path: this.vouchersPage});
                }, this.httpError);
            },
            onCalcFee: function () {
                this.httpPrepare();
                this.$http.put(this.apiurl('voucher/' + this.voucher_id + '/calcfee'), this.getSaveData()).then(function (response) {
                    this.httpSuccess(response);
                    this.reloadVoucher();
                }, this.httpError);
            },
            onPreProcess: function () {
                this.doVoucherPreprocess();
            },
            doSaveGuests: function () {
                this.httpPrepare();
                this.$http.post(this.apiurl('voucher/' + this.voucher_id + '/saveguests'), this.getSaveData()).then(function (response) {
                    this.httpSuccess(response);
                    this.setLatestVoucher(this.voucher_id);
                    this.doGoBack();
                }, this.httpError);
            },
            onApply: function () {
                this.httpPrepare();
                this.$http.post(this.apiurl('voucher/' + this.voucher_id + '/save'), this.getSaveData()).then(function (response) {
                    response = this.httpSuccess(response);
                    this.setLatestVoucher(this.voucher_id);
                    this.reloadVoucher();
                }, this.httpError);
            },
            onCreateTask: function () {
                this.showCreateTaskDialog = true;
            },
            doVoucherRequest: function () {
                let comment = '';
                if (this.is(this.requestOtherRoom) || this.is(this.requestOtherObject) || this.is(this.requestOtherDates)) {
                    comment += "Рассматриваем варианты: "
                    if (this.is(this.requestOtherRoom)) {
                        comment += "заселения в другом номере, ";
                    }
                    if (this.is(this.requestOtherObject)) {
                        comment += "заселения в другом объекте, ";
                    }
                    if (this.is(this.requestOtherDates)) {
                        comment += "смещение дат";
                    }
                    comment += "\n";
                }
                if (this.is(this.addComment)) {
                    comment += this.addComment + "\n";
                }
                this.httpPrepare();
                this.$http.put(this.apiurl('voucher/' + this.voucher_id + '/request'), this.getSaveData()).then(function (response) {
                    this.httpSuccess(response);
                    this.doGoBack();
                }, this.httpError);
            },
            doVoucherPresence: function () {
                this.httpPrepare();
                this.$http.put(this.apiurl('voucher/' + this.voucher_id + '/presence'), {addcomment: this.addComment}).then(function (response) {
                    this.httpSuccess(response);
                    this.doGoBack();
                }, this.httpError);
            },
            doVoucherPreprocess: function () {
                this.httpPrepare();
                this.$http.put(this.apiurl('voucher/' + this.voucher_id + '/preprocess'), {addcomment: this.addComment}).then(function (response) {
                    this.httpSuccess(response);
                    this.doGoBack();
                }, this.httpError);
            },
            doVoucherAbsence: function () {
                this.httpPrepare();
                this.$http.put(this.apiurl('voucher/' + this.voucher_id + '/absence'), {addcomment: this.addComment}).then(function (response) {
                    this.httpSuccess(response);
                    this.doGoBack();
                }, this.httpError);
            },
            doVoucherBookReject: function () {
                this.httpPrepare();
                this.$http.put(this.apiurl('voucher/' + this.voucher_id + '/book-reject'), {addcomment: this.addComment}).then(function (response) {
                    this.httpSuccess(response);
                    this.doGoBack();
                }, this.httpError);
            },
            doGoBack: function () {
                this.reloadView();
                //this.$router.push({ path: this.vouchersPage});
            },

            onAgree: function () {
//                if (this.is(this._date_begin_iso)) {
                let today = new Date();
                let n = Math.round(new Date().getTimezoneOffset() / 60);
                today.setHours(-n, 0, 0, 0);
                let s = this._date_begin_iso;
                console.log('onAgrees = ', s);
                s.setHours(-n, 0, 0, 0);

                if (today > s) {
                    this.showAgreeModal = true;
                } else {
                    if (today < s) {
                        this.doSmAgree();
                    } else {
                        this.doSmAgree();
                    }
                }
//                }
            },


            doSmAgree: function () {

                this.$validator.validate().then(valid => {
                    if (valid) {
                        if (!this.validateRoom()) {
                            console.log('FAILED validateRoom');
                            return false;
                        }
                        if (!this.validateVoucherData()) {
                            console.log('FAILED validateVoucherData');
                            return false;
                        }
                        if (!this.validatePersonsProgram()) {
                            console.log('FAILED validatePersonsProgram');
                            return false;
                        }
                        if (!this.validatePersonsData()) {
                            console.log('FAILED validatePersonsData');
                            return false;
                        }
                        this.httpPrepare();
                        this.$http.put(this.apiurl('voucher/' + this.voucher_id + '/reserve-requerst'), this.getSaveData()).then(function (response) {
                            response = this.httpSuccess(response);
                            this.doGoBack();
                        }, this.httpError);
                    } else {
                        this.errorModal = true;
                        this.errorTitle = 'Заполните обязательные поля';
                        this.errorText = 'Для отправки в бронирование все обязательныке поля должны быть заполнены';
                    }
                });
            },

            doCommand: function (command, b_return) {
                this.httpPrepare();
                this.$http.put(this.apiurl('voucher/' + this.voucher_id + '/' + command), this.getSaveData()).then(function (response) {
                    response = this.httpSuccess(response);
                    if (b_return) {
                        this.doGoBack();
                    } else {
                        this.reloadVoucher();
                    }
                }, this.httpError);
            },

            doSmPayAgency: function () {
                this.doCommand('agency-pay', true);
            },
            doSmPaySystem: function () {
                this.doCommand('system-pay', true);
            },
            doSmSetbook: function () {
                this.doCommand('setbook', false);
            },

            onClickBookReject: function () {
                this.showBookRejectModal = true;
            },

            onClickBookApply: function () {
                this.showBookingCreateDialog = true;
            },

            onSendToExecute: function () {
                this.httpPrepare();
                this.$http.put(this.apiurl('voucher/' + this.voucher_id + '/execute')).then(function (response) {
                    this.httpSuccess(response);
                    this.doGoBack();
                }, this.httpError);
            },
            onClickRevert: function () {
                this.httpPrepare();
                this.$http.put(this.apiurl('voucher/' + this.voucher_id + '/revert')).then(function (response) {
                    this.httpSuccess(response);
                    this.reloadVoucher();
                }, this.httpError);
            },
            onClickClone: function () {
                this.httpPrepare();
                this.$http.post(this.apiurl('voucher/' + this.voucher_id + '/clone')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.$router.push({path: '/agent/voucher/' + response.payload})
                    this.$forceUpdate();
                }, this.httpError);
            },
            onGetInvoice: function () {
                this.httpPrepare();
                this.$http.put(this.apiurl('voucher/' + this.voucher_id + '/get-invoice'), this.getSaveData()).then(function (response) {
                    this.httpSuccess(response);
                    this.reloadVoucher();
                }, this.httpError);
            },
            onAddPhone: function () {
                this.voucher.telenums.push({number: '', info: '', new: 1});
            },
            onClose: function () {
                this.doGoBack();
            },


            enumerateGuests: function () {
                let maxid = 0;
                for (let i = 0; i < this.guests.length; i++) {
                    if (this.guests[i].invoice_subid > maxid) maxid = this.guests[i].invoice_subid;
                }
                for (let i = 0; i < this.guests.length; i++) {
                    if (this.guests[i].invoice_subid === 0) {
                        maxid++;
                        this.guests[i].invoice_subid = maxid;
                    }
                }

            },
            onPrintInvoice: function () {
                this.enumerateGuests();
                this.printMode = 'invoice';
                this.voucher.faximile = false;

                this.showInvoicesSplitDialog = true;

                // if (this.guests.length>1) {
                //     this.showInvoicesSplitDialog = true;
                // }
                // else {
                //     this.showPrintFaximileDialog = true;
                // }
            },
            onPrintContract: function () {
                this.enumerateGuests();
                this.printMode = 'contract';
                this.voucher.faximile = false;
                this.showInvoicesSplitDialog = true;

                // if (this.guests.length>1) {
                //     this.showInvoicesSplitDialog = true;
                // }
                // else {
                //     this.showPrintFaximileDialog = true;
                // }
            },
            onPrintVoucher: function () {
                this.printMode = 'voucher';
                this.voucher.faximile = false;
                this.showPrintFaximileDialog = true;
            },

            onCreateDocuments: function () {
                this.printMode = 'create';
                this.voucher.faximile = false;
                this.showPrintFaximileDialog = true;
            },

            onCreateTicket: function () {
                console.log('onCreateTicket');
                this.createTicket(this.voucher_id, null, null, null);
            },


            doPrint: function () {
                console.log('doPrint', this.printMode, this.voucher.faximile);
                switch (this.printMode) {
                    case 'invoice':
                        this.printInvoice(this.voucher, this.voucher.faximile);
                        break;
                    case 'contract':
                        this.printContract(this.voucher, this.voucher.faximile);
                        break;
                    case 'voucher':
                        this.printVoucher(this.voucher, this.voucher.faximile);
                        break;
                    case 'create':
                        this.createDocuments(this.voucher, this.voucher.faximile);
                        break;
                }
            },
            onClickChangeUser: function () {
                this.showChangeUserDialog = true;
            },
            onBooked: function () {
                this.reloadVoucher();
                //this.doGoBack();
            },
            person_valid: function (j) {

                if (this.ageTarif(this.guests[j].age) === AGE_TARIF_NOTPERMIT) {
                    return false;
                }

                let infants = 0;
                let noninfants = 0;
                for (let i = 0; i < this.guests.length; i++) {
                    if (this.ageTarif(this.guests[i].age) === AGE_TARIF_INFANT) {
                        infants++;
                    } else {
                        noninfants++;
                    }
                }

                if (this.ageTarif(this.guests[j].age) === AGE_TARIF_INFANT) {
                    if (infants > 2) {
                        return false;
                    }
                } else {
                    if (noninfants > this.room_total_places) {
                        return false;
                    }
                }

                return true;
            },
            findProgram: function (program_id) {
                if (this.programs) {
                    for (let i = 0; i < this.programs.length; i++) {
                        if (this.programs[i].id == program_id) {
                            return this.programs[i];
                        }
                    }
                }
                return null;
            },
            ageTarif: function (age) {
                if (!this.hotel) return AGE_TARIF_BASE;
                if (age <= this.hotel.child_age1) {
                    return this.hotel.tarif_type1;
                }
                if (age <= this.hotel.child_age2) {
                    return this.hotel.tarif_type2;
                }
                if (age <= this.hotel.child_age3) {
                    return this.hotel.tarif_type3;
                }
                if (age <= this.hotel.child_age4) {
                    return this.hotel.tarif_type4;
                }
                if (age <= this.hotel.child_age5) {
                    return this.hotel.tarif_type5;
                }
                if (age <= 17) {
                    return this.hotel.tarif_type6;
                }
                return AGE_TARIF_BASE;
            },
            resetPerson: function (i) {
                if (!this.loaded) return;
                //console.log('resetPerson ' + i)
                this.guests[i].summa = 0;
                this.guests[i].discount_value = 0;
                this.guests[i].with_discount_value = 0;
                this.guests[i].prepay_value = 0;
                this.guests[i].discount_percent = 0;
                this.guests[i].prepay_percent = 0;
            },
            resetPersons: function (resetProgram) {
                if (!this.loaded) return;
                for (let i = 0; i < this.guests.length; i++) {
                    if (resetProgram) {
                        this.guests[i].t_obj_tariff_id = 0;
                    }
                    this.resetPerson(i);
                }
                this.calculateVoucherTotals();
                this.calculation = null;
            },
            initGuestValues(i) {
                //console.log('i='+i)
                if (this.isGuestsLoaded()) {
                    if (!this.guests[i].summa) {
                        this.guests[i].summa = 0;
                    }
                    if (!this.guests[i].discount_percent) {
                        this.guests[i].discount_percent = 0;
                    }
                    if (!this.guests[i].discount_value) {
                        this.guests[i].discount_value = 0;
                    }
                    if (!this.guests[i].with_discount_value) {
                        this.guests[i].with_discount_value = 0;
                    }
                    if (!this.guests[i].prepay_percent) {
                        this.guests[i].prepay_percent = 0;
                    }
                    if (!this.guests[i].prepay_value) {
                        this.guests[i].prepay_value = 0;
                    }
                }
            },
            validatePersonsProgram: function () {
                let programSet = true;
                this.guests.forEach(function (guest /* , i, guests */) {
                    if (!guest.t_obj_tariff_id) {
                        programSet = false;
                    }
                });
                if (!programSet) {
                    this.errorModal = true;
                    this.errorText = 'Для автоматического расчета должен быть выбран диапазон дат, номер и тарифы размещения у всех туристов';
                    this.errorTitle = 'Не выбраны тарифы у всех туристов';
                    return false;
                }
                return true;
            },
            toArray: function (param) {
                if (typeof (param) === 'string') {
                    return [param];
                }
                return param;
            },
            calculateVoucherTotals: function () {
                if (this.isGuestsLoaded() && this.isHotelLoaded()) {
                    //console.log('calculateVoucherTotals');
                    this.voucher.summa_full = 0;
                    this.voucher.summa_discount = 0;
                    this.voucher.summa_payment = 0;
                    this.voucher.summa_prev = 0;

                    this.voucher.sys_commission_company_summa = Math.round(this.voucher.summa_full * this.voucher.company.procent_commission / 100);
                    this.voucher.sys_commission_obj_summa = Math.round(this.voucher.summa_full * this.hotel.sys_commission_obj_procent / 100);
                    this.voucher.summa_ref_obj = Math.round(this.voucher.summa_full * this.hotel.procent_ref_obj / 100);
                    this.voucher.summa_ref_agency = this.voucher.summa_ref_obj - this.voucher.sys_commission_company_summa - this.voucher.sys_commission_obj_summa;

                    // % вознаграждения которое сичтема уплачивает агентству
                    this.voucher.procent_ref_agency = this.hotel.procent_ref_obj - this.voucher.company.procent_commission - this.hotel.sys_commission_obj_procent;
                    this.voucher.procent_ref_obj = this.hotel.procent_ref_obj;
                    this.voucher.sys_commission_obj_procent = this.hotel.sys_commission_obj_procent;
                }
            },

            validateRoom: function () {
                if (!this.voucher || !this.voucher.id) {
                    alert("косяк ....");
                    return false;
                }
                if (!this.voucher.t_city_id) {
                    alert("Для продолжения необходимо выбрать Город");
                    return false;
                }
                if (!this.voucher.t_obj_items_id) {
                    alert("Для продолжения необходимо выбрать Объект отдыха");
                    return false;
                }
                if (!this.voucher || !this.voucher.id || !this.voucher.t_obj_rooms_id) {
                    alert("Для продолжения необходимо выбрать Номер");
                    return false;
                }
                return true;
            },


            validateVoucherData: function () {
                if (!this.voucher || !this.voucher.id) {
                    alert("косяк ....");
                    return false;
                }
                return true;
            },
            validatePersonsData: function () {
                for (let i = 0; i < this.guests.length; i++) {
                    if (!this.guests[i].surname) {
                        return false;
                    }
                }
                return true;
            },

            onShowHotelDialog(hotel_id) {
                this.hotelInfoId = hotel_id;
                this.showHotelDialog = true;
            },

            onHideHotelDialog: function () {
                this.hotelInfoId = null;
            },

            onPlacesCheck: function () {
                this.availability
                let program_id = this.guests[0].t_obj_tariff_id;

                this.httpPrepare();
                this.$http.put(this.apiurl('quota/check'), {
                    hotel_id: this.voucher.t_obj_items_id,
                    room_id: this.voucher.t_obj_rooms_id,
                    program_id: program_id,
                    checkin: this._date_begin_iso,
                    checkout: this._date_end_iso,
                }).then(function (response) {
                    response = this.httpSuccess(response);
                    if (response.result === 'success') {
                        //this.console_log(response.payload);
                        this.availability = response.payload;
                    } else {
                        this.error_log(response.error);
                    }
                }, this.httpError);
            },

            onClickRequest: function () {
                let today = new Date();
                let n = Math.round(new Date().getTimezoneOffset() / 60);
                today.setHours(-n, 0, 0, 0);
                this._date_begin_iso.setHours(-n, 0, 0, 0);
                //console.log(today + ' ' + this._date_begin_iso);
                if (today > this._date_begin_iso) {
                    this.showRequestDenyModal = true;
                } else {
                    if (today < this._date_begin_iso) {
                        //alert ("Заезд будет");
                        this.showRequestConfirm = true;
                    } else {
                        //alert ("Заезд сегодня");
                        this.showRequestConfirm = true;
                    }
                }
            },

            onClickPresence: function () {
                this.showPresenceConfirm = true;
            },

            onClickAbsence: function () {
                this.showAbsenceConfirm = true;
            },

            onTryBook: function () {
//                this.httpPrepare();
//                this.$http.put(this.apiurl('voucher/'+this.voucher.id+'/book'),
//                this.httpSuccess(response);
//                    { voucher:this.voucher,guests:this.guests,telenums:this.telenums }).then(function (response) {
//                    response = this.httpSuccess(response);
//                    if (response.result === 'success')
//                    {
//                        this.console_log(response.payload);
//                        this.availability = response.payload;
//                    }
//                    else {
//                        this.error_log(response.error);
//                    }
//                }, this.httpError);
            },

            onChangeDates: function (param) {
                if (!this.loaded) return;
                this.initial_skip.onChangeDates;
                //console.log('onChangeDates this.initial_skip.onChangeDates=', this.initial_skip.onChangeDates)

                if (this.initial_skip.onChangeDates-- > 0) {
                    //console.log('skip onChangeDates', param)
                } else {
                    //console.log('do onChangeDates', param)
                    this.resetPersons(false);
                    this.availability = null;
                }
            },

            onChangeApplyDiscount: function (discount) {
                if (discount.no_combine && this.applied_discounts[discount.id.toString()]) {
                    for (let i = 0; i < this.discounts.length; i++) {
                        if (this.discounts[i].id != discount.id) {
                            this.applied_discounts[this.discounts[i].id.toString()] = false;
                        }
                    }
                } else if (!discount.no_combine && this.applied_discounts[discount.id.toString()]) {
                    for (let i = 0; i < this.discounts.length; i++) {
                        if (this.discounts[i].no_combine) {
                            this.applied_discounts[this.discounts[i].id.toString()] = false;
                        }
                    }
                }
            },

            onDoChangeUser: function (newUser) {
                this.httpPrepare();
                this.$http.put(this.apiurl('voucher/' + this.voucher.id + '/chuser'), newUser).then(function (response) {
                    this.httpSuccess(response);
                    this.doGoBack();
                }, this.httpError);
            },

            reloadVoucher: function () {
                this.reloadView();
            },

            bookindBillPayed: function () {
                this.showBookingBillPayedModal = true;
            },

            bookindInvoicePayed: function () {
                this.showBookingInvoicePayedModal = true;
            },

            handleAgreeOk: function () {
                this.doSmAgree();
            },

            onSetbook: function () {
                this.doCommand('setbook', false);
            },

            onAgencyPay: function () {
                this.resetBalance().loadSelfBalance(function (self) {
                    self.showPayAgencyModal = true;
                }, this);
            },

            onSysPay: function () {
                console.log(this.hotel);
                this.resetBalance().loadBalance(this.hotel.company_id, function (self) {
                    self.showPaySystemModal = true;
                }, this);
            },

            onSelectCustomer: function () {
                this.showCreateCustomerDialog = true;
            },

            createCustomer: function () {
                this.doCreateCustomer();
            },

            customerSelected: function () {
                console.log('this.voucher.customer_id', this.voucher.customer_id);
                this.httpPrepare();
                let self = this;
                this.$http.post(this.apiurl('voucher/' + this.voucher_id + '/save'), this.getSaveData()).then(function (response) {
                    response = this.httpSuccess(response);
                    self.setLatestVoucher(this.voucher_id);
                    self.doAssignCustomer(this.voucher.customer_id);
                }, this.httpError);
            },

            customerChanged: function () {
            },

            onCancelBooking: function (booking) {
                this.bookingToCancel = booking.id;
                this.showCancelBookingModal = true;
            },

            onCancelTicket: function (ticket) {
                this.ticketToCancel = ticket.id;
                this.showCancelTicketModal = true;
            },

            createBooking: function () {
                this.showCreateBookingModal = true;
            },

            handleCancelBooking: function () {
                this.cancelBooking(this.bookingToCancel, function (self) {
                    self.reloadVoucher()
                }, this);
            },

            handleCancelTicket: function () {
                this.cancelTicket(this.ticketToCancel, function (self) {
                    self.reloadVoucher()
                }, this);
            },

            handleCreateBooking: function () {
                this.showBookingCreateDialog = true;
            },

            printBooking: function (b) {
                this.printBookingBill(b);
            },

            onSavedTicket: function() {
                this.loadTicketsForVoucher(this.voucher_id);
            },

            calc_fee_amount: function(b) {
                return b.bill_fee;
            },

            calc_fee_pc: function(b) {
                if (this.hotel && this.voucher && this.voucher.company) {
                    return Math.round(b.bill_fee/b.amount*10000)/100;
                }
            },

            fee_changed: function(b) {
                if (this.hotel && this.voucher && this.voucher.company) {
                    return Math.round(b.fee_value/b.amount*1000)/10 != this.hotel.procent_ref_obj;
                }
            },
        },
        computed: {
            is_voucher: function () {
                return this.voucher && (this.voucher !== null) && this.voucher.id;
            },
            is_voucher_company: function () {
                return this.is_voucher && (this.voucher.company) && (this.voucher.company !== null);
            },
            is_voucher_bookings: function () {
                return this.is_voucher && (this.voucher.bookings) && (this.voucher.bookings !== null) && (this.voucher.bookings.length > 0);
            },
            is_voucher_files: function () {
                return this.is_voucher && (this.voucher.files) && (this.voucher.files !== null) && (this.voucher.files.length > 0);
            },
            is_tickets: function () {
                return this.is_voucher && (this.voucher.tickets) && (this.voucher.tickets !== null) && (this.voucher.tickets.length > 0);
            },
            company_title: function () {
                if (!this.is_voucher_company) return null;
                return this.voucher.company.title;
            },
            is_voucher_payments_ag: function () {
                return this.is_voucher && (this.voucher.payments_ag) && (this.voucher.payments_ag !== null) && (this.voucher.payments_ag.length > 0);
            },
            //            my_company_title: function () {
            //                if (!this.mycompany) return null;
            //                return this.mycompany.title;
            //            },
            room_total_places: function () {
                if (!this.is_room_loaded) return 0;
                return this.room.places_main + this.room.places_additionally;
            },
            room_places_additionally: function () {
                if (!this.is_room_loaded) return 0;
                return this.formatNumberRoditelny(this.room.places_additionally);
            },
            infant_age: function () {
                if (!this.isHotelLoaded()) return '';
                return this.hotel.child_age1;
            },
            infant_free: function () {
                if (!this.isHotelLoaded()) return '';
                return (this.hotel.child_age1 <= 17) && (this.hotel.tarif_type1 === AGE_TARIF_INFANT);
            },
            infant_disabled: function () {
                if (!this.isHotelLoaded()) return '';
                return (this.hotel.child_age1 <= 17) && (this.hotel.tarif_type1 === AGE_TARIF_NOTPERMIT);
            },
            persons_valid: function () {
                let infants = 0;
                let noninfants = 0;
                for (let i = 0; i < this.guests.length; i++) {
                    if (this.ageTarif(this.guests[i].age) === AGE_TARIF_NOTPERMIT) {
                        return false;
                    }
                    if (this.ageTarif(this.guests[i].age) === AGE_TARIF_INFANT) {
                        infants++;
                    } else {
                        noninfants++;
                    }
                }
                if (infants > 2) {
                    return false;
                }
                if (noninfants > this.room_total_places) {
                    return false;
                }
                return true;
            },
            noninfants: function () {
                let noninfants_ = 0;
                for (let i = 0; i < this.guests.length; i++) {
                    if (this.ageTarif(this.guests[i].age) !== AGE_TARIF_INFANT) {
                        noninfants_++;
                    }
                }
                return noninfants_;
            },
            infants: function () {
                let infants_ = 0;
                for (let i = 0; i < this.guests.length; i++) {
                    if (this.ageTarif(this.guests[i].age) === AGE_TARIF_INFANT) {
                        infants_++;
                    }
                }
                return infants_;
            },
            can_delete_bed: function () {
                return this.guests.length > 1;
            },
            can_add_bed: function () {
                if (!this.hotel) return false;
                if (!this.room) return false;

                if ((this.hotel.child_age1 < 17) && (this.hotel.tarif_type1 === AGE_TARIF_INFANT)) {
                    return this.guests.length < (this.room_total_places) + 2;
                } else {
                    return this.guests.length < (this.room_total_places);
                }
            },
            min_days: function () {
                let m = 0;
                for (let i = 0; i < this.guests.length; i++) {
                    console.log(this.guests[i].t_obj_tariff_id);
                    let t = this.findProgram(this.guests[i].t_obj_tariff_id);
                    if (t) {
                        console.log(t);
                        if (t.count_day_min > 0) {
                            if (m == 0) {
                                m = t.count_day_min;
                            } else {
                                if (t.count_day_min > m) {
                                    m = t.count_day_min;
                                }
                            }
                        }
                    }
                }
                console.log('m=' + m);
                return m;
            },
            availabilityText: function () {
                if (!this.availability) {
                    return false;
                }
                let $r = '';
                if (this.availability.roomAvailable) {
                    $r = "<div class='alert alert-success'>Номера выбранной категории доступны для бронирования</div>";
                } else if (!this.availability.hotelAvailable) {
                    $r = "<div class='alert alert-danger'>Ваще ничего доступного нет. Печалька.</div>";
                } else { // if (this.availability.hotelAvailable)
                    $r = "<div class='alert alert-danger'>Номера выбранной категории не доступны. Но есть такие вот номера:<br>";
                    $r += "</div>";
                }
                return $r;
            },
            getCheckInDateTime: function () {
                if (!this.hotel) return '';
                return 'заезд после ' + this.printDate(this._date_begin_iso) + ' ' + this.hotel.time_check_in;
            },
            getCheckOutDateTime: function () {
                if (!this.hotel) return '';

                if (this.hotel.time_check_out === '00:00') {
                    let newdate = new Date(this._date_end_iso);
                    newdate.setDate(newdate.getDate() + 1);
                    return 'выезд до ' + this.printDate(newdate) + ' ' + this.hotel.time_check_out;
                } else {
                    return 'выезд до ' + this.printDate(this._date_end_iso) + ' ' + this.hotel.time_check_out;
                }
            },

            days: {
                get: function () {
                    if (!this.hotel) return 0;
                    let d0 = new Date(this._date_begin_iso);
                    let d1 = new Date(this._date_end_iso);
                    let one_day = 1000 * 60 * 60 * 24;
                    let days = d1 - d0;
                    days = Math.round(days / one_day);
                    if ((this.hotel.time_check_out !== '00:00') && (this.hotel.time_check_in !== '00:00') && (this.hotel.time_check_payment !== '00:00')) {
                        return days;
                    } else {
                        return days + 1;
                    }
                },
                set: function (days) {
                    let d = new Date(this._date_begin_iso);

                    if ((this.hotel.time_check_out !== '00:00') && (this.hotel.time_check_in !== '00:00') && (this.hotel.time_check_payment !== '00:00')) {

                    } else {
                        days -= 1;
                    }

                    d.setDate(d.getDate() + days);
                    this._date_end_iso = d;
                    this.onChangeDates(1);
                }
            },

            booking_limit: function () {
                if (!this.balance) return 0;

                if (this.voucher.company.credit_limit < this.balance.debet) {
                    let overdraft = this.balance.debet - this.voucher.company.credit_limit;
                    if (overdraft > this.balance.active) {
                        return 0;
                    }
                    return this.balance.active - overdraft;
                }
                return this.balance.active;
            },

            credit_limit: function () {
                if (!this.balance) return 0;

                if (this.voucher.company.credit_limit < this.balance.debet) {
                    let overdraft = this.balance.debet - this.voucher.company.credit_limit;
                    if (overdraft > this.balance.active) {
                        return 0;
                    }
                    return this.balance.active - overdraft;
                }

                return this.balance.active + this.voucher.company.credit_limit - this.balance.debet;
            },

            object_booking_limit: function () {
                if (!this.balance) return 0;
                return this.balance.s_active;
            },

            can_agency_pay_book: function () {
                return this.credit_limit >= this.bookingsSumBill()
            },

            can_system_pay_book: function () {
                return this.object_booking_limit >= this.bookingsSumInvoice()
            },

            _penalty: {
                get: function () {
                    return this.penalty / 100;
                },
                set: function (val) {
                    this.penalty = isNaN(val) ? '' : Math.round(val * 100);
                }
            },

            status_bell_class: function () {
                if (this.status_expired) {
                    return 'rot-l';
                }
                return '';
            },

            must_close_status: function () {
                if (this.canSmManagerStatusControl(this.voucher) && this.is_manager_or_buh) {
                    return true;
                }
                if (this.canSmAgentStatusControl(this.voucher) && this.is_agent_or_agency) {
                    return true;
                }
                return false;
            },

            _date_begin_iso: {
                get: function () {
                    if (!this.is(this.voucher.date_begin_iso)) {
                        let newdate = new Date();
                        newdate.setDate(newdate.getDate() + 1);
                        return newdate;
                    }
                    return new Date(this.voucher.date_begin_iso.slice(0, 10));
                },
                set: function (v) {
                    this.voucher.date_begin_iso = dateToISO(v);
                }
            },

            _date_end_iso: {
                get: function () {
                    if (!this.is(this.voucher.date_end_iso)) {
                        let newdate = new Date();
                        newdate.setDate(newdate.getDate() + 11);
                        return newdate;
                    }
                    return new Date(this.voucher.date_end_iso.slice(0, 10));
                },
                set: function (v) {
                    this.voucher.date_end_iso = dateToISO(v);
                }
            },

            _close_status_at: {
                get: function () {
                    if (!this.is(this.voucher.close_status_at)) return null;
                    return this.parseDateTime(this.voucher.close_status_at);
                },
                set: function (v) {
                    this.voucher.close_status_at = dateTimeToISO(v);
                }
            },

            _passport_date_issue: {
                get: function () {
                    if (!this.is(this.voucher.passport_date_issue)) return null;
                    return new Date(this.voucher.passport_date_issue.slice(0, 10));
                },
                set: function (v) {
                    this.voucher.passport_date_issue = dateToISO(v);
                }
            },

            _ag_invoice_date: {
                get: function () {
                    if (!this.is(this.voucher.ag_invoice_date)) return null;
                    return new Date(this.voucher.ag_invoice_date.slice(0, 10));
                },
                set: function (v) {
                    this.voucher.ag_invoice_date = dateToISO(v);
                    console.log('_ag_invoice_date.set', this.voucher.ag_invoice_date)
                }
            },

            _summa_transfer: {
                get: function () {
                    return this.voucher.summa_transfer / 100;
                },
                set: function (val) {
                    this.voucher.summa_transfer = isNaN(val) ? '' : Math.round(val * 100);
                }
            },

            _receive_payment: {
                get: function () {
                    return this.voucher.receive_payment / 100;
                },
                set: function (val) {
                    this.voucher.receive_payment = isNaN(val) ? '' : Math.round(val * 100);
                }
            },

            _summa_driver: {
                get: function () {
                    return this.voucher.summa_driver / 100;
                },
                set: function (val) {
                    this.voucher.summa_driver = isNaN(val) ? '' : Math.round(val * 100);
                }
            },

            _date_meeting_iso: {
                get: function () {
                    let dt = moment(this.voucher.date_meeting_iso);
                    console.log(dt.toDate());
                    let t = dt.format('HH:mm');
                    let d = dt.startOf('day').toDate();
                    return d;
                },
                set: function (v) {
                    let dt = moment(this.voucher.date_meeting_iso);
                    let t = moment(dt.format('HH:mm'), 'HH:mm');
                    let dn = moment(v, 'HH:mm');
                    dn = dn.add(t.hour(), 'hour').add(t.minute(), 'minute');
                    this.voucher.date_meeting_iso = dn.format("YYYY-MM-DD HH:mm:ss");
                }
            },

            _meeting_time: {
                get: function () {
                    let dt = moment(this.voucher.date_meeting_iso);
                    let t = dt.format('HH:mm');
                    let d = dt.startOf('day').toDate();
                    return t;
                },
                set: function (v) {
                    let dt = moment(this.voucher.date_meeting_iso);
                    let d = dt.startOf('day');
                    let tn = moment(v, 'HH:mm');
                    d = d.add(tn.hour(), 'hour').add(tn.minute(), 'minute');
                    this.voucher.date_meeting_iso = d.format("YYYY-MM-DD HH:mm:ss");
                }
            },

            tickets_total: function () {
                if (!this.is_tickets) {
                    return 0;
                }
                let total = 0;
                for (let i = 0; i < this.tickets.length; i++) {
                    if (!this.tickets[i].disabled) {
                        total += this.tickets[i].price;
                    }
                }
                return total;
            }



        },

        beforeDestroy() {
        },
        watch: {
            '$route.params': {
                handler(newValue) {
                    if (newValue) {
                        this.voucher_id = this.$router.currentRoute.params.voucher_id;
                        this.loadVoucher(this.voucher_id, this.voucherAfterLoad);
                    }
                },
                immediate: true,
            },
        },
        created: function () {
            this.loadDrivers();
        },
    }
</script>

<style scoped>
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

    @keyframes animate-bell {
        0% {
            -moz-transform: rotate(30deg) scale(2); /* Для Firefox */
            -ms-transform: rotate(30deg) scale(2); /* Для IE */
            -webkit-transform: rotate(30deg) scale(2); /* Для Safari, Chrome, iOS */
            -o-transform: rotate(30deg) scale(2); /* Для Opera */
            transform: rotate(30deg) scale(2);
        }
        50% {
            -moz-transform: rotate(-30deg); /* Для Firefox */
            -ms-transform: rotate(-30deg); /* Для IE */
            -webkit-transform: rotate(-30deg); /* Для Safari, Chrome, iOS */
            -o-transform: rotate(-30deg); /* Для Opera */
            transform: rotate(-30deg);
        }
        100% {
            -moz-transform: rotate(30deg) scale(2); /* Для Firefox */
            -ms-transform: rotate(30deg) scale(2); /* Для IE */
            -webkit-transform: rotate(30deg) scale(2); /* Для Safari, Chrome, iOS */
            -o-transform: rotate(30deg) scale(2); /* Для Opera */
            transform: rotate(30deg) scale(2);
        }
    }

    @keyframes animate-hitexh {
        0% {
            color: #000000;
            text-shadow: 0 0 5px white, 0 0 10px white, 0 0 15px white, 0 0 20px crimson, 0 0 35px crimson, 0 0 40px crimson, 0 0 50px crimson, 0 0 75px crimson;
            font-weight: bold;
        }
        50% {
            color: #FF0000;
            text-shadow: none;
            font-weight: bold;
        }
        100% {
            color: #000000;
            text-shadow: 0 0 5px white, 0 0 10px white, 0 0 15px white, 0 0 20px crimson, 0 0 35px crimson, 0 0 40px crimson, 0 0 50px crimson, 0 0 75px crimson;
            font-weight: bold;
        }
    }

    .rot-l {
        position: relative;
        display: inline-block;
        animation: animate-bell 0.5s ease infinite;
    }

    .hitexh {
        position: relative;
        display: inline-block;
        animation: animate-hitexh 1.6s ease infinite;
    }

</style>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
